(function () {
  var UNIT = 335;
  function productUnitPrice() {
    try {
      var product = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      if (product && product.variants && product.variants.length) {
        var idEl = document.querySelector('form[action*="/cart/add"] [name="id"]');
        var id = idEl && idEl.value ? String(idEl.value) : "";
        var v = product.variants[0];
        for (var i = 0; i < product.variants.length; i++) {
          if (id && String(product.variants[i].id) === id) v = product.variants[i];
        }
        var cents = Number(v.price);
        if (cents > 0) return cents / 100;
      }
    } catch (e) {}
    var og = document.querySelector('meta[property="og:price:amount"]');
    if (og && og.content) {
      var n = parseFloat(og.content);
      if (n > 0) return n;
    }
    return UNIT;
  }
  function productLooksLikeMiura() {
    var t = ((location.pathname || "") + " " + (document.title || "")).toLowerCase();
    var og = document.querySelector('meta[property="og:title"]');
    if (og && og.content) t += " " + String(og.content).toLowerCase();
    var h1 = document.querySelector("h1");
    if (h1) t += " " + (h1.textContent || "").toLowerCase();
    return t.indexOf("miura") > -1;
  }
  function optionIsHidden(opt) {
    if (!opt) return true;
    if (opt.classList.contains("bold_option_hidden")) return true;
    try {
      var cs = window.getComputedStyle(opt);
      if (cs.display === "none" || cs.visibility === "hidden") return true;
    } catch (e) {}
    return false;
  }
  function optionTitleIsOptional(opt) {
    var t = text(opt.querySelector(".bold_option_title")).toLowerCase();
    return t.indexOf("shaft brand") > -1;
  }
  var SHAFT_IMG = "";
  var GRIP_IMGS = {
  "Golf Pride CP Grey Standard (NEW)": "https://fairwayjockey.com/cdn/shop/files/Untitled_design-108_460x.png?v=1785967175",
  "CP Grey Standard (NEW)": "https://fairwayjockey.com/cdn/shop/files/Untitled_design-108_460x.png?v=1785967175",
  "Golf Pride CP Grey Midsize (NEW)": "https://fairwayjockey.com/cdn/shop/files/Untitled_design-108_460x.png?v=1785967175",
  "CP Grey Midsize (NEW)": "https://fairwayjockey.com/cdn/shop/files/Untitled_design-108_460x.png?v=1785967175",
  "Golf Pride MCC Black White Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-MCC-Black-White_460x.png?v=1644357187",
  "MCC Black White Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-MCC-Black-White_460x.png?v=1644357187",
  "Golf Pride MCC Black White Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-MCC-Black-White_460x.png?v=1644357187",
  "MCC Black White Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-MCC-Black-White_460x.png?v=1644357187",
  "Golf Pride MCC Black Standard": "https://fairwayjockey.com/cdn/shop/files/Golf-Pride-MCC-Black_460x.png?v=1698189334",
  "MCC Black Standard": "https://fairwayjockey.com/cdn/shop/files/Golf-Pride-MCC-Black_460x.png?v=1698189334",
  "Golf Pride MCC Black Midsize": "https://fairwayjockey.com/cdn/shop/files/Golf-Pride-MCC-Black_460x.png?v=1698189334",
  "MCC Black Midsize": "https://fairwayjockey.com/cdn/shop/files/Golf-Pride-MCC-Black_460x.png?v=1698189334",
  "Golf Pride MCC Black Red Standard": "https://fairwayjockey.com/cdn/shop/files/MCC-Black-Red_460x.png?v=1698189854",
  "MCC Black Red Standard": "https://fairwayjockey.com/cdn/shop/files/MCC-Black-Red_460x.png?v=1698189854",
  "Golf Pride MCC Black Red Midsize": "https://fairwayjockey.com/cdn/shop/files/MCC-Black-Red_460x.png?v=1698189854",
  "MCC Black Red Midsize": "https://fairwayjockey.com/cdn/shop/files/MCC-Black-Red_460x.png?v=1698189854",
  "Golf Pride MCC Black Blue Standard": "https://fairwayjockey.com/cdn/shop/files/Golf-Pride-MCC-Blue-Black_460x.png?v=1698189388",
  "MCC Black Blue Standard": "https://fairwayjockey.com/cdn/shop/files/Golf-Pride-MCC-Blue-Black_460x.png?v=1698189388",
  "Golf Pride MCC Black Blue Midsize": "https://fairwayjockey.com/cdn/shop/files/Golf-Pride-MCC-Blue-Black_460x.png?v=1698189388",
  "MCC Black Blue Midsize": "https://fairwayjockey.com/cdn/shop/files/Golf-Pride-MCC-Blue-Black_460x.png?v=1698189388",
  "Golf Pride MCC Black White Align Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-MCC-Black-White-Align_460x.png?v=1625672882",
  "MCC Black White Align Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-MCC-Black-White-Align_460x.png?v=1625672882",
  "Golf Pride MCC Black White Align Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-MCC-Black-White-Align_460x.png?v=1625672882",
  "MCC Black White Align Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-MCC-Black-White-Align_460x.png?v=1625672882",
  "Golf Pride MCC Plus 4 Gray Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-MCC-Plus-4-Gray-Std_460x.png?v=1640113689",
  "MCC Plus 4 Gray Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-MCC-Plus-4-Gray-Std_460x.png?v=1640113689",
  "Golf Pride MCC Plus 4 Gray Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-MCC-Plus-4-Gray-Std_460x.png?v=1640113689",
  "MCC Plus 4 Gray Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-MCC-Plus-4-Gray-Std_460x.png?v=1640113689",
  "Golf Pride MCC Plus 4 Gray Jumbo": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-MCC-Plus-4-Gray-Std_460x.png?v=1640113689",
  "MCC Plus 4 Gray Jumbo": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-MCC-Plus-4-Gray-Std_460x.png?v=1640113689",
  "Golf Pride MCC Plus 4 Red Standard": "https://fairwayjockey.com/cdn/shop/products/MCC-Plus-4-Red_460x.png?v=1625672882",
  "MCC Plus 4 Red Standard": "https://fairwayjockey.com/cdn/shop/products/MCC-Plus-4-Red_460x.png?v=1625672882",
  "Golf Pride MCC Plus 4 Orange Standard": "https://fairwayjockey.com/cdn/shop/files/mccplus4orange_1_460x.jpg?v=1740696871",
  "MCC Plus 4 Orange Standard": "https://fairwayjockey.com/cdn/shop/files/mccplus4orange_1_460x.jpg?v=1740696871",
  "Golf Pride MCC Plus 4 Blue Standard": "https://fairwayjockey.com/cdn/shop/products/MCC-Plus-4-Teams-Blue_460x.png?v=1646862822",
  "MCC Plus 4 Blue Standard": "https://fairwayjockey.com/cdn/shop/products/MCC-Plus-4-Teams-Blue_460x.png?v=1646862822",
  "Golf Pride MCC Plus 4 Blue Midsize": "https://fairwayjockey.com/cdn/shop/products/MCC-Plus-4-Teams-Blue_460x.png?v=1646862822",
  "MCC Plus 4 Blue Midsize": "https://fairwayjockey.com/cdn/shop/products/MCC-Plus-4-Teams-Blue_460x.png?v=1646862822",
  "Golf Pride MCC Plus 4 Align Gray Standard": "https://fairwayjockey.com/cdn/shop/products/MCC-Plus-4-Align-Gray_460x.png?v=1625672882",
  "MCC Plus 4 Align Gray Standard": "https://fairwayjockey.com/cdn/shop/products/MCC-Plus-4-Align-Gray_460x.png?v=1625672882",
  "Golf Pride MCC Plus 4 Align Gray Midsize": "https://fairwayjockey.com/cdn/shop/products/MCC-Plus-4-Align-Gray_460x.png?v=1625672882",
  "MCC Plus 4 Align Gray Midsize": "https://fairwayjockey.com/cdn/shop/products/MCC-Plus-4-Align-Gray_460x.png?v=1625672882",
  "Golf Pride MCC Align Max Black Grey Standard": "https://fairwayjockey.com/cdn/shop/files/golfpridealignmax_460x.jpg?v=1739893434",
  "MCC Align Max Black Grey Standard": "https://fairwayjockey.com/cdn/shop/files/golfpridealignmax_460x.jpg?v=1739893434",
  "Golf Pride MCC Align Max Black Grey Midsize": "https://fairwayjockey.com/cdn/shop/files/golfpridealignmax_460x.jpg?v=1739893434",
  "MCC Align Max Black Grey Midsize": "https://fairwayjockey.com/cdn/shop/files/golfpridealignmax_460x.jpg?v=1739893434",
  "Golf Pride MCC Align Plus 4 Max Black Grey Standard": "https://fairwayjockey.com/cdn/shop/files/golfpridealign_460x.jpg?v=1739893430",
  "MCC Align Plus 4 Max Black Grey Standard": "https://fairwayjockey.com/cdn/shop/files/golfpridealign_460x.jpg?v=1739893430",
  "Golf Pride MCC Align Plus 4 Max Black Grey Midsize": "https://fairwayjockey.com/cdn/shop/files/golfpridealign_460x.jpg?v=1739893430",
  "MCC Align Plus 4 Max Black Grey Midsize": "https://fairwayjockey.com/cdn/shop/files/golfpridealign_460x.jpg?v=1739893430",
  "Golf Pride Z-Grip Cord Standard": "https://fairwayjockey.com/cdn/shop/products/Z-Grip-Cord_460x.png?v=1691076770",
  "Z-Grip Cord Standard": "https://fairwayjockey.com/cdn/shop/products/Z-Grip-Cord_460x.png?v=1691076770",
  "Golf Pride Z-Grip Cord Midsize": "https://fairwayjockey.com/cdn/shop/products/Z-Grip-Cord_460x.png?v=1691076770",
  "Z-Grip Cord Midsize": "https://fairwayjockey.com/cdn/shop/products/Z-Grip-Cord_460x.png?v=1691076770",
  "Golf Pride Z-Grip Cord Align Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-Z-Grip-Align_460x.png?v=1645032556",
  "Z-Grip Cord Align Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-Z-Grip-Align_460x.png?v=1645032556",
  "Golf Pride Z-Grip Cord Align Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-Z-Grip-Align_460x.png?v=1645032556",
  "Z-Grip Cord Align Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-Z-Grip-Align_460x.png?v=1645032556",
  "Golf Pride Tour Velvet 360 Black Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-Tour-Velvet-360_460x.png?v=1637350886",
  "Tour Velvet 360 Black Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-Tour-Velvet-360_460x.png?v=1637350886",
  "Golf Pride Tour Velvet 360 White Standard": "https://fairwayjockey.com/cdn/shop/files/TV360White_460x.png?v=1718208674",
  "Tour Velvet 360 White Standard": "https://fairwayjockey.com/cdn/shop/files/TV360White_460x.png?v=1718208674",
  "Golf Pride Tour Velvet 360 White Midsize": "https://fairwayjockey.com/cdn/shop/files/TV360White_460x.png?v=1718208674",
  "Tour Velvet 360 White Midsize": "https://fairwayjockey.com/cdn/shop/files/TV360White_460x.png?v=1718208674",
  "Golf Pride Tour Velvet Midsize": "https://fairwayjockey.com/cdn/shop/products/Tour-Velvet_f7936e52-19ff-4e8a-b175-9b7a2125d0ea_460x.png?v=1625672882",
  "Tour Velvet Midsize": "https://fairwayjockey.com/cdn/shop/products/Tour-Velvet_f7936e52-19ff-4e8a-b175-9b7a2125d0ea_460x.png?v=1625672882",
  "Golf Pride Tour Velvet Align Standard": "https://fairwayjockey.com/cdn/shop/products/MCC-Tour-Velvet-Align-Standard_460x.png?v=1625672882",
  "Tour Velvet Align Standard": "https://fairwayjockey.com/cdn/shop/products/MCC-Tour-Velvet-Align-Standard_460x.png?v=1625672882",
  "Golf Pride Tour Velvet Align Midsize": "https://fairwayjockey.com/cdn/shop/products/MCC-Tour-Velvet-Align-Standard_460x.png?v=1625672882",
  "Tour Velvet Align Midsize": "https://fairwayjockey.com/cdn/shop/products/MCC-Tour-Velvet-Align-Standard_460x.png?v=1625672882",
  "Golf Pride Tour Velvet Cord Midsize": "https://fairwayjockey.com/cdn/shop/files/gp-tour-velvet-cord_460x.jpg?v=1713453306",
  "Tour Velvet Cord Midsize": "https://fairwayjockey.com/cdn/shop/files/gp-tour-velvet-cord_460x.jpg?v=1713453306",
  "Golf Pride Tour Velvet Plus 4 Standard": "https://fairwayjockey.com/cdn/shop/files/Tour_Velvet_Plus_4_460x.jpg?v=1724185898",
  "Tour Velvet Plus 4 Standard": "https://fairwayjockey.com/cdn/shop/files/Tour_Velvet_Plus_4_460x.jpg?v=1724185898",
  "Golf Pride Tour Velvet Plus 4 Midsize": "https://fairwayjockey.com/cdn/shop/files/Tour_Velvet_Plus_4_460x.jpg?v=1724185898",
  "Tour Velvet Plus 4 Midsize": "https://fairwayjockey.com/cdn/shop/files/Tour_Velvet_Plus_4_460x.jpg?v=1724185898",
  "Golf Pride Tour Wrap 2G Black Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-Tour-Wrap_460x.png?v=1625672882",
  "Tour Wrap 2G Black Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-Tour-Wrap_460x.png?v=1625672882",
  "Golf Pride Tour Wrap 2G Black Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-Tour-Wrap_460x.png?v=1625672882",
  "Tour Wrap 2G Black Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-Tour-Wrap_460x.png?v=1625672882",
  "Golf Pride Tour Wrap 2G Black Jumbo": "https://fairwayjockey.com/cdn/shop/files/tour_wrap_jumbo_black_grip_dropdown_460x.jpg?v=1768250807",
  "Tour Wrap 2G Black Jumbo": "https://fairwayjockey.com/cdn/shop/files/tour_wrap_jumbo_black_grip_dropdown_460x.jpg?v=1768250807",
  "Golf Pride Tour Wrap 2G White Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-Tour-Wrap-2G-White_460x.png?v=1674510995",
  "Tour Wrap 2G White Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-Tour-Wrap-2G-White_460x.png?v=1674510995",
  "Golf Pride Tour Wrap 2G White Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-Tour-Wrap-2G-White_460x.png?v=1674510995",
  "Tour Wrap 2G White Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-Tour-Wrap-2G-White_460x.png?v=1674510995",
  "Golf Pride Tour Wrap 2G Blue Standard": "https://fairwayjockey.com/cdn/shop/files/2g_blue_460x.jpg?v=1756855532",
  "Tour Wrap 2G Blue Standard": "https://fairwayjockey.com/cdn/shop/files/2g_blue_460x.jpg?v=1756855532",
  "Golf Pride CP2 Pro Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CP2-Pro_460x.png?v=1644506726",
  "CP2 Pro Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CP2-Pro_460x.png?v=1644506726",
  "Golf Pride CP2 Pro Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CP2-Pro_460x.png?v=1644506726",
  "CP2 Pro Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CP2-Pro_460x.png?v=1644506726",
  "Golf Pride CP2 Pro Jumbo": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CP2-Pro_460x.png?v=1644506726",
  "CP2 Pro Jumbo": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CP2-Pro_460x.png?v=1644506726",
  "Golf Pride CP2 Wrap Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CP2-Wrap-Standard_460x.png?v=1625672882",
  "CP2 Wrap Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CP2-Wrap-Standard_460x.png?v=1625672882",
  "Golf Pride CP2 Wrap Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CP2-Wrap-Standard_460x.png?v=1625672882",
  "CP2 Wrap Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CP2-Wrap-Standard_460x.png?v=1625672882",
  "Golf Pride CP2 Wrap Jumbo": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CP2-Wrap-Standard_460x.png?v=1625672882",
  "CP2 Wrap Jumbo": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CP2-Wrap-Standard_460x.png?v=1625672882",
  "Golf Pride CPX Grey Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CPX-Grip_460x.png?v=1672963625",
  "CPX Grey Standard": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CPX-Grip_460x.png?v=1672963625",
  "Golf Pride CPX Grey Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CPX-Grip_460x.png?v=1672963625",
  "CPX Grey Midsize": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CPX-Grip_460x.png?v=1672963625",
  "Golf Pride CPX Grey Jumbo": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CPX-Grip_460x.png?v=1672963625",
  "CPX Grey Jumbo": "https://fairwayjockey.com/cdn/shop/products/Golf-Pride-CPX-Grip_460x.png?v=1672963625",
  "Iomic Sticky 2.3 Black": "https://fairwayjockey.com/cdn/shop/files/sticky2.3black_e22519fe-fdc2-4f8f-8e85-1fb688798e0b_460x.jpg?v=1733332360",
  "Sticky 2.3 Black": "https://fairwayjockey.com/cdn/shop/files/sticky2.3black_e22519fe-fdc2-4f8f-8e85-1fb688798e0b_460x.jpg?v=1733332360",
  "Iomic Sticky 2.3 Blue": "https://fairwayjockey.com/cdn/shop/files/sticky2.3blue_debc6ffa-16d8-4a61-bea7-022a31a0b705_460x.jpg?v=1733332344",
  "Sticky 2.3 Blue": "https://fairwayjockey.com/cdn/shop/files/sticky2.3blue_debc6ffa-16d8-4a61-bea7-022a31a0b705_460x.jpg?v=1733332344",
  "Iomic Sticky 2.3 Red": "https://fairwayjockey.com/cdn/shop/files/sticky2.3red_3423acaa-2484-404b-82d6-bc8830add648_460x.jpg?v=1733332349",
  "Sticky 2.3 Red": "https://fairwayjockey.com/cdn/shop/files/sticky2.3red_3423acaa-2484-404b-82d6-bc8830add648_460x.jpg?v=1733332349",
  "Iomic Sticky 2.3 White": "https://fairwayjockey.com/cdn/shop/files/sticky2.3white_b8c03188-75fe-467d-846d-df56682c2f3e_460x.jpg?v=1733332371",
  "Sticky 2.3 White": "https://fairwayjockey.com/cdn/shop/files/sticky2.3white_b8c03188-75fe-467d-846d-df56682c2f3e_460x.jpg?v=1733332371",
  "Iomic Sticky 2.3 Orange": "https://fairwayjockey.com/cdn/shop/files/sticky2.3orange_977354ae-1b89-4bf5-a050-315fba6ca128_460x.jpg?v=1733332365",
  "Sticky 2.3 Orange": "https://fairwayjockey.com/cdn/shop/files/sticky2.3orange_977354ae-1b89-4bf5-a050-315fba6ca128_460x.jpg?v=1733332365",
  "Iomic Sticky 2.3 Grey": "https://fairwayjockey.com/cdn/shop/files/Sticky_2B2.3_2B-_2BP_460x.jpg?v=1770138931",
  "Sticky 2.3 Grey": "https://fairwayjockey.com/cdn/shop/files/Sticky_2B2.3_2B-_2BP_460x.jpg?v=1770138931",
  "Iomic Sticky 2.3 Grey Camo": "https://fairwayjockey.com/cdn/shop/files/Stick23GreyCamo_460x.jpg?v=1738598375",
  "Sticky 2.3 Grey Camo": "https://fairwayjockey.com/cdn/shop/files/Stick23GreyCamo_460x.jpg?v=1738598375",
  "Iomic Sticky 2.3 Sky Blue": "https://fairwayjockey.com/cdn/shop/files/Iomic23SkyBlue_460x.jpg?v=1738598224",
  "Sticky 2.3 Sky Blue": "https://fairwayjockey.com/cdn/shop/files/Iomic23SkyBlue_460x.jpg?v=1738598224",
  "Iomic Sticky 2.3 Green": "https://fairwayjockey.com/cdn/shop/files/iomic23green_460x.jpg?v=1768339123",
  "Sticky 2.3 Green": "https://fairwayjockey.com/cdn/shop/files/iomic23green_460x.jpg?v=1768339123",
  "Iomic Sticky 2.3 Green Camo": "https://fairwayjockey.com/cdn/shop/files/Sticky_Camo_2.3_-_GREEN_460x.jpg?v=1738598700",
  "Sticky 2.3 Green Camo": "https://fairwayjockey.com/cdn/shop/files/Sticky_Camo_2.3_-_GREEN_460x.jpg?v=1738598700",
  "Iomic Sticky 2.3 Blue Camo": "https://fairwayjockey.com/cdn/shop/files/iomicbluecamo_460x.jpg?v=1750792755",
  "Sticky 2.3 Blue Camo": "https://fairwayjockey.com/cdn/shop/files/iomicbluecamo_460x.jpg?v=1750792755",
  "Iomic Sticky 3.5 Black": "https://fairwayjockey.com/cdn/shop/files/3.5black_9f8442ab-3101-4ea1-9d5d-8f78339aed7c_460x.jpg?v=1733332293",
  "Sticky 3.5 Black": "https://fairwayjockey.com/cdn/shop/files/3.5black_9f8442ab-3101-4ea1-9d5d-8f78339aed7c_460x.jpg?v=1733332293",
  "Iomic Sticky 3.5 Blue": "https://fairwayjockey.com/cdn/shop/files/3.5blue_a9ffb93d-5c06-4dc2-ae9e-00cef0940090_460x.jpg?v=1733332295",
  "Sticky 3.5 Blue": "https://fairwayjockey.com/cdn/shop/files/3.5blue_a9ffb93d-5c06-4dc2-ae9e-00cef0940090_460x.jpg?v=1733332295",
  "Iomic Sticky 3.5 Red": "https://fairwayjockey.com/cdn/shop/files/3.5red_5a01d79b-d36f-42a1-b469-c57559c14134_460x.jpg?v=1733332298",
  "Sticky 3.5 Red": "https://fairwayjockey.com/cdn/shop/files/3.5red_5a01d79b-d36f-42a1-b469-c57559c14134_460x.jpg?v=1733332298",
  "Iomic Sticky Black Midsize": "https://fairwayjockey.com/cdn/shop/files/blackmidsize_f479ce7b-d24e-4834-b76b-e857cebf1c5c_460x.jpg?v=1733332375",
  "Sticky Black Midsize": "https://fairwayjockey.com/cdn/shop/files/blackmidsize_f479ce7b-d24e-4834-b76b-e857cebf1c5c_460x.jpg?v=1733332375",
  "Iomic Sticky Red Midsize": "https://fairwayjockey.com/cdn/shop/files/sticky2.3red_3423acaa-2484-404b-82d6-bc8830add648_460x.jpg?v=1733332349",
  "Sticky Red Midsize": "https://fairwayjockey.com/cdn/shop/files/sticky2.3red_3423acaa-2484-404b-82d6-bc8830add648_460x.jpg?v=1733332349",
  "Iomic Sticky Jumbo 5.5 Black": "https://fairwayjockey.com/cdn/shop/files/Sticky_2BMID_2B-_2BBLACK_460x.jpg?v=1770138162",
  "Sticky Jumbo 5.5 Black": "https://fairwayjockey.com/cdn/shop/files/Sticky_2BMID_2B-_2BBLACK_460x.jpg?v=1770138162",
  "Iomic Sticky Jumbo 5.5 Blue": "https://fairwayjockey.com/cdn/shop/files/jumbo-blue-product_9a438090-7316_460x.jpg?v=1770138057",
  "Sticky Jumbo 5.5 Blue": "https://fairwayjockey.com/cdn/shop/files/jumbo-blue-product_9a438090-7316_460x.jpg?v=1770138057",
  "Iomic iX SA 2.0 Black": "https://fairwayjockey.com/cdn/shop/files/ix-sa-black-800w_460x.jpg?v=1779834163",
  "iX SA 2.0 Black": "https://fairwayjockey.com/cdn/shop/files/ix-sa-black-800w_460x.jpg?v=1779834163",
  "Iomic iXx 2.3 Blue": "https://fairwayjockey.com/cdn/shop/files/2.3blue_2_460x.jpg?v=1733332330",
  "iXx 2.3 Blue": "https://fairwayjockey.com/cdn/shop/files/2.3blue_2_460x.jpg?v=1733332330",
  "Iomic iXx 2.3 Red": "https://fairwayjockey.com/cdn/shop/files/2.3red-gripdropdowns_460x.jpg?v=1733332335",
  "iXx 2.3 Red": "https://fairwayjockey.com/cdn/shop/files/2.3red-gripdropdowns_460x.jpg?v=1733332335",
  "Iomic Sticky 1.8 White/Silver": "https://fairwayjockey.com/cdn/shop/files/Sticky_2B1.8_2B-_2BWHITE_460x.jpg?v=1754496721",
  "Sticky 1.8 White/Silver": "https://fairwayjockey.com/cdn/shop/files/Sticky_2B1.8_2B-_2BWHITE_460x.jpg?v=1754496721",
  "Iomic Sticky 1.8 Blue/Sky Blue": "https://fairwayjockey.com/cdn/shop/files/Sticky_2B1.8_2B-_2BBLUE_460x.jpg?v=1754496786",
  "Sticky 1.8 Blue/Sky Blue": "https://fairwayjockey.com/cdn/shop/files/Sticky_2B1.8_2B-_2BBLUE_460x.jpg?v=1754496786",
  "Iomic Sticky 1.8 Lavender/White": "https://fairwayjockey.com/cdn/shop/files/Sticky_2B1.8_2B-_2BLAVENDER_460x.jpg?v=1754496693",
  "Sticky 1.8 Lavender/White": "https://fairwayjockey.com/cdn/shop/files/Sticky_2B1.8_2B-_2BLAVENDER_460x.jpg?v=1754496693"
};

  try {
    var tag = document.querySelector('link[rel="stylesheet"][href*="roc-builder"]');
    if (tag) SHAFT_IMG = tag.href.replace(/roc-builder\.css.*$/, "shaft-placeholder.png");
  } catch (e) {}

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  function text(el) {
    return ((el && el.textContent) || "").replace(/\s+/g, " ").trim();
  }

  // SC Custom Price often appends " £15.00" after our "(+£15)" label — parse either form.
  function parsePrice(label) {
    var s = (label || "") + "";
    var m = s.match(/\(\+?\s*[£$]\s*([\d.]+)\)/i);
    if (m) return parseFloat(m[1]);
    m = s.match(/(?:^|[\s])\+?\s*[£$]\s*([\d.]+)\s*$/i);
    return m ? parseFloat(m[1]) : 0;
  }

  // Strip label upcharge AND SC-appended Custom Price so cards show the name once.
  function cleanName(label) {
    return ((label || "") + "")
      .replace(/\s*\(\+?\s*[£$]\s*[\d.]+\)/gi, "")
      .replace(/\s*\+?\s*[£$]\s*[\d.]+\s*$/i, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function optionList(select) {
    return Array.prototype.filter.call(select.options, function (o) {
      if (!o.value || !o.text) return false;
      var low = o.text.toLowerCase();
      if (low.indexOf("select") > -1 || o.text.indexOf("--") > -1) return false;
      if (o.disabled || o.hidden) return false;
      if (o.classList && o.classList.contains("bold_option_hidden")) return false;
      if (o.style && o.style.display === "none") return false;
      return true;
    });
  }

  function httpImage(u) {
    if (!u || typeof u !== "string") return "";
    u = u.trim();
    if (!u || u.charAt(0) === "#" || u.indexOf("rgb") === 0) return "";
    if (u.indexOf("//") === 0) return "https:" + u;
    if (u.indexOf("http") === 0) return u;
    return "";
  }

  function swatchUrl(sw) {
    if (!sw) return "";
    if (typeof sw === "string") return httpImage(sw);
    return httpImage(sw.url || sw.src || sw.image || sw.image_url || sw.imageUrl || sw.swatch || "");
  }

  var swatchByName = {};
  var swatchMapReady = false;
  var swatchMapFetching = false;

  function rememberSwatch(name, url) {
    if (!name) return;
    var img = swatchUrl(url);
    if (!img) return;
    var raw = String(name).toLowerCase();
    swatchByName[raw] = img;
    var cleaned = cleanName(String(name)).toLowerCase();
    if (cleaned) swatchByName[cleaned] = img;
  }

  function ingestValueList(vals) {
    if (!vals || !vals.length) return;
    for (var j = 0; j < vals.length; j++) {
      var v = vals[j];
      if (!v) continue;
      rememberSwatch(v.name || v.value, v.swatch);
    }
  }

  function ingestOptionList(opts) {
    if (!opts || !opts.length) return;
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      if (!o) continue;
      ingestValueList(o.optionValues);
      ingestValueList(o.options_values);
    }
  }

  function ingestSets(sets) {
    if (!sets || !sets.length) return;
    for (var si = 0; si < sets.length; si++) {
      var s = sets[si];
      if (!s) continue;
      ingestOptionList(s.options);
    }
  }

  function ingestOptionProduct(op) {
    if (!op) return;
    ingestSets(op.optionSets);
    ingestSets(op.option_sets);
    ingestOptionList(op.options);
  }

  function ingestBoldTree() {
    try {
      var bold = window.BOLD && BOLD.options;
      var app = bold && bold.app;
      var products = (app && app.optionProducts) || [];
      for (var p = 0; p < products.length; p++) ingestOptionProduct(products[p]);
      if (app) {
        ingestSets(app.optionSets);
        ingestSets(app.option_sets);
        ingestOptionProduct(app.option_product || app.optionProduct);
      }
      if (bold) ingestOptionProduct(bold.option_product || bold.optionProduct);
    } catch (e) {}
  }

  function lookupSwatch(label) {
    ingestBoldTree();
    var want = (label || "").toLowerCase();
    if (!want) return "";
    var clean = cleanName(want).toLowerCase();
    if (swatchByName[want]) return swatchByName[want];
    if (clean && swatchByName[clean]) return swatchByName[clean];
    var best = "";
    var bestLen = 0;
    var keys = Object.keys(swatchByName);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (!k) continue;
      if (want.indexOf(k) === -1 && k.indexOf(want) === -1 &&
          (!clean || (clean.indexOf(k) === -1 && k.indexOf(clean) === -1))) continue;
      if (k.length > bestLen) {
        bestLen = k.length;
        best = swatchByName[k];
      }
    }
    return best;
  }

  function resolveProductId() {
    try {
      var shopify = window.BOLD && BOLD.common && BOLD.common.Shopify;
      var handle = "";
      try { handle = (shopify && shopify.product && shopify.product.handle) || ""; } catch (e) {}
      if (!handle) {
        var pm = (location.pathname || "").match(/\/products\/([^/?#]+)/);
        if (pm) handle = decodeURIComponent(pm[1]);
      }
      if (shopify && shopify.products && handle && shopify.products[handle] && shopify.products[handle].id) {
        return shopify.products[handle].id;
      }
    } catch (e) {}
    try { if (window.meta && meta.product && meta.product.id) return meta.product.id; } catch (e) {}
    try {
      var sa = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      if (sa && sa.id) return sa.id;
    } catch (e) {}
    try {
      var el = document.querySelector("[data-product-id], [data-productid], form[action*='/cart/add'] [name='product-id']");
      if (el) {
        var dv = el.getAttribute("data-product-id") || el.getAttribute("data-productid") || el.value;
        if (dv && /^\d{8,}$/.test(String(dv))) return dv;
      }
    } catch (e) {}
    try {
      var scripts = document.getElementsByTagName("script");
      for (var i = 0; i < scripts.length; i++) {
        var t = scripts[i].textContent || "";
        if (t.indexOf("saveVariant") === -1 && t.indexOf('"product"') === -1 && t.indexOf("product_id") === -1) continue;
        var m = t.match(/"product_id"\s*:\s*(\d{8,})/) || t.match(/product_id["']?\s*[:=]\s*["']?(\d{8,})/);
        if (m) return m[1];
      }
    } catch (e) {}
    // last resort for this test product only (Miura TC-201 [TEST])
    return 15048562540920;
  }

  function fetchSwatchMap(done) {
    ingestBoldTree();
    if (Object.keys(swatchByName).length) {
      if (done) done();
      return;
    }
    try {
      var base = "https://options.shopapps.site/v2/";
      try {
        if (window.BOLD && BOLD.options && BOLD.options.path && BOLD.options.path.path) {
          base = BOLD.options.path.path;
        }
      } catch (e) {}
      var domain = "";
      try { domain = BOLD.common.Shopify.shop.permanent_domain; } catch (e) {}
      var productId = resolveProductId();
      var tmp = "";
      try { tmp = (BOLD.common && BOLD.common.cacheParams && BOLD.common.cacheParams.options) || ""; } catch (e) {}
      if (!domain || !productId) {
        if (done) done();
        return;
      }
      var url = base + domain + "/generate_option/" + productId + "?tmp=" + tmp;
      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        try {
          var op = (data && data.option_product) || data;
          ingestOptionProduct(op);
          var sets = (op && (op.option_sets || op.optionSets)) || [];
          for (var si = 0; si < sets.length; si++) {
            var opts = (sets[si] && sets[si].options) || [];
            for (var i = 0; i < opts.length; i++) {
              var vals = (opts[i] && (opts[i].options_values || opts[i].optionValues)) || [];
              for (var j = 0; j < vals.length; j++) {
                var v = vals[j];
                if (!v) continue;
                rememberSwatch(v.value || v.name, v.swatch);
              }
            }
          }
        } catch (e) {}
        if (done) done();
      }).catch(function () {
        if (done) done();
      });
    } catch (e) {
      if (done) done();
    }
  }

  function boldSwatchImage(label) {
    try {
      var want = (label || "").toLowerCase();
      var clean = cleanName(want).toLowerCase();
      var products = window.BOLD && BOLD.options && BOLD.options.app && BOLD.options.app.optionProducts;
      if (!products || !want) return "";
      var fuzzy = "";
      for (var p = 0; p < products.length; p++) {
        var sets = products[p].optionSets || [];
        for (var si = 0; si < sets.length; si++) {
          var opts = sets[si].options || [];
          for (var i = 0; i < opts.length; i++) {
            var vals = opts[i].optionValues || [];
            for (var j = 0; j < vals.length; j++) {
              var n = ((vals[j].name || "") + "").toLowerCase();
              if (!n) continue;
              var nClean = cleanName(n).toLowerCase();
              var exact = n === want || n === clean || nClean === want || nClean === clean;
              if (!exact && want.indexOf(n) === -1 && n.indexOf(want) === -1 &&
                  want.indexOf(nClean) === -1 && nClean.indexOf(want) === -1) continue;
              var url = swatchUrl(vals[j].swatch);
              if (!url) continue;
              if (exact) return url;
              if (!fuzzy) fuzzy = url;
            }
          }
        }
      }
      return fuzzy;
    } catch (e) {}
    return "";
  }

  function optionImageFromNode(node) {
    if (!node) return "";
    var img = node.querySelector ? node.querySelector("img") : null;
    if (img && img.src && img.src.indexOf("data:") !== 0) return img.src;
    var bg = node.getAttribute && (node.getAttribute("data-image") || node.getAttribute("data-swatch") || node.getAttribute("data-src"));
    if (bg) return bg;
    var st = node.style && node.style.backgroundImage;
    if (!st || st === "none") {
      var cs = window.getComputedStyle && getComputedStyle(node);
      st = cs && cs.backgroundImage;
    }
    if (st && st !== "none") {
      var m = st.match(/url\(["']?(.*?)["']?\)/);
      if (m && m[1] && m[1] !== "none") return m[1];
    }
    return "";
  }

  function imageFromOption(opt, value, label) {
    if (!opt) return "";
    var inp = null;
    if (value != null && value !== "") {
      try {
        inp = opt.querySelector('input[value="' + String(value).replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '"]');
      } catch (e) {
        inp = null;
      }
    }
    var nodes = [];
    if (inp) {
      var lab = (inp.closest && inp.closest("label")) || (inp.id && opt.querySelector('label[for="' + inp.id + '"]')) || inp.parentNode;
      if (lab) nodes.push(lab);
      nodes.push(inp.parentNode, inp);
      var scope = lab || inp.parentNode || opt;
      if (scope && scope.querySelectorAll) {
        scope.querySelectorAll('.bold_option_value_swatch, .swatch, [style*="background-image"]').forEach(function (el) {
          nodes.push(el);
        });
      }
    } else if (opt.querySelectorAll) {
      opt.querySelectorAll('.bold_option_value_swatch, .swatch, [style*="background-image"]').forEach(function (el) {
        var nearby = text(el) || text(el.parentNode);
        if (label && nearby && nearby.toLowerCase().indexOf(String(label).toLowerCase()) === -1 &&
            String(label).toLowerCase().indexOf(nearby.toLowerCase()) === -1) return;
        nodes.push(el);
      });
    }
    for (var i = 0; i < nodes.length; i++) {
      var url = httpImage(optionImageFromNode(nodes[i]));
      if (url) return url;
    }
    return "";
  }

  function optionItems(opt) {
    var select = opt.querySelector("select");
    if (select && select.options && select.options.length) {
      return optionList(select).map(function (o) {
        return {
          value: o.value,
          text: o.text,
          image: lookupSwatch(o.text) || httpImage(optionImageFromNode(o)) || imageFromOption(select.closest(".bold_option") || opt, o.value, o.text) || boldSwatchImage(o.text),
          select: select
        };
      });
    }
    var items = [];
    opt.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(function (inp) {
      if (!inp.value) return;
      if (inp.disabled || inp.hidden) return;
      var row = (inp.closest && (inp.closest(".bold_option_value") || inp.closest("li") || inp.closest("label"))) || inp.parentNode;
      if (row && row.classList && (row.classList.contains("bold_option_hidden") || row.classList.contains("bold_hidden_option") || row.style.display === "none")) return;
      var lab = (inp.closest && inp.closest("label")) || (inp.id && opt.querySelector('label[for="' + inp.id + '"]')) || inp.parentNode;
      var raw = text(lab);
      if (!raw || raw.toLowerCase().indexOf("choose") === 0) return;
      items.push({
        value: inp.value,
        text: raw,
        image: lookupSwatch(raw) || httpImage(optionImageFromNode(lab)) || httpImage(optionImageFromNode(inp)) || httpImage(optionImageFromNode(inp.parentNode)) || imageFromOption(opt, inp.value, raw) || boldSwatchImage(raw),
        input: inp
      });
    });
    return items;
  }

  function applyOptionItem(item) {
    if (item.select) {
      item.select.value = item.value;
      item.select.dispatchEvent(new Event("change", { bubbles: true }));
      return;
    }
    if (item.input) {
      item.input.checked = true;
      item.input.dispatchEvent(new Event("change", { bubbles: true }));
      item.input.dispatchEvent(new Event("click", { bubbles: true }));
    }
  }

  function selectedItemValue(opt) {
    var sel = opt.querySelector("select");
    if (sel && sel.value) return sel.value;
    var checked = opt.querySelector("input:checked");
    return checked ? checked.value : "";
  }

  function optionKey(options) {
    return options.map(function (o) { return o.value + ":" + o.text; }).join("|");
  }


  function optionTitleText(opt) {
    var el = opt.querySelector(".bold_option_title");
    return el ? (el.textContent || "").replace(/\s+/g, " ").trim() : "";
  }

  function tourGripBrand(root) {
    var brand = "";
    root.querySelectorAll(".bold_option").forEach(function (opt) {
      if ((optionTitleText(opt) || "").toLowerCase().indexOf("grip brand") === -1) return;
      var checked = opt.querySelector("input:checked");
      if (checked) {
        var lab = opt.querySelector("label[for='" + (checked.id || "") + "']") || checked.closest("label");
        brand = ((lab && lab.textContent) || checked.value || "").toLowerCase();
      }
    });
    return brand;
  }

  function tourGripPriceLabel(name) {
    var raw = (name || "").replace(/\s+/g, " ").trim();
    var fromLabel = parsePrice(raw);
    var base = cleanName(raw);
    // Always trust SC labels. Never invent Miura GP/Iomic upcharges in the theme.
    return fromLabel ? (base + " (+£" + fromLabel.toFixed(0) + ")") : base;
  }

  function looksLikeLabForm(root) {
    var titles = "";
    root.querySelectorAll(".bold_option_title").forEach(function (el) {
      titles += " " + ((el.textContent || "").toLowerCase());
    });
    return titles.indexOf("putting style") > -1 ||
      titles.indexOf("alignment mark") > -1 ||
      titles.indexOf("putter color") > -1 ||
      titles.indexOf("putter colour") > -1;
  }

  // Blade/mallet putters (Evnroll etc.): Head / Shaft / Grip — not LAB, not Tour shafts.
  function looksLikeSimplePutter(root) {
    if (looksLikeLabForm(root)) return false;
    var titles = "";
    root.querySelectorAll(".bold_option_title").forEach(function (el) {
      titles += " " + ((el.textContent || "").toLowerCase());
    });
    if (titles.indexOf("loft sleeve") > -1) return false;
    if (titles.indexOf("club type") > -1 || titles.indexOf("club model") > -1) return false;
    if (titles.indexOf("shaft material") > -1 || titles.indexOf("club number") > -1) return false;
    var page = ((location.pathname || "") + " " + (document.title || "")).toLowerCase();
    var h1 = document.querySelector("h1");
    if (h1) page += " " + (h1.textContent || "").toLowerCase();
    var putterPage = page.indexOf("putter") > -1 || page.indexOf("evnroll") > -1;
    var hasShaft = titles.indexOf("shaft") > -1;
    var hasGrip = titles.indexOf("grip") > -1;
    // Head fields (hand/loft/lie) can be added in SC after the layout is live.
    return putterPage && hasShaft && hasGrip;
  }

  function chooseLabel(title) {
    var cleaned = (title || "").replace(/^select\s+/i, "").replace(/^choose\s+/i, "").trim();
    return cleaned ? ("Choose " + cleaned) : "Choose …";
  }

  function titleOf(opt) {
    return text(opt.querySelector(".bold_option_title"));
  }

  function hasPriceTbd(label) {
    return /\(\s*price\s*tbd\s*\)/i.test(label || "");
  }

  function tourGripImg(name) {
    if (!name) return "";
    if (GRIP_IMGS[name]) return GRIP_IMGS[name];
    var cleaned = cleanName(name);
    if (GRIP_IMGS[cleaned]) return GRIP_IMGS[cleaned];
    var keys = Object.keys(GRIP_IMGS);
    var n = name.toLowerCase();
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i].toLowerCase();
      if (n.indexOf(k) > -1 || k.indexOf(n) > -1) return GRIP_IMGS[keys[i]];
    }
    return "";
  }


  function ensurePreview() {
    var box = document.querySelector(".roc-shaft-preview");
    if (box) return box;
    box = document.createElement("div");
    box.className = "roc-shaft-preview";
    box.innerHTML = "<img alt=\"Preview\">";
    document.body.appendChild(box);
    document.addEventListener("click", function (ev) {
      if (ev.target.closest && ev.target.closest(".roc-shaft-thumb")) return;
      hidePreview(true);
    });
    return box;
  }

  function showPreview(src, card, pin) {
    if (!src || !card) return;
    var box = ensurePreview();
    box.querySelector("img").src = src;
    box.classList.add("is-visible");
    box.classList.toggle("is-pinned", !!pin);
    var r = card.getBoundingClientRect();
    var w = Math.min(320, window.innerWidth - 24);
    var left = r.right + 10;
    if (left + w > window.innerWidth - 12) left = Math.max(12, r.left - w - 10);
    if (left < 12) left = 12;
    var top = Math.max(12, Math.min(r.top, window.innerHeight - 180));
    box.style.width = w + "px";
    box.style.left = left + "px";
    box.style.top = top + "px";
  }

  function hidePreview(force) {
    var box = document.querySelector(".roc-shaft-preview");
    if (!box) return;
    if (box.classList.contains("is-pinned") && !force) return;
    box.classList.remove("is-visible", "is-pinned");
  }

  function bindCardPreview(card) {
    var img = card.querySelector("img");
    if (!img || !img.src) return;
    card.addEventListener("mouseenter", function () { showPreview(img.src, card, false); });
    card.addEventListener("mouseleave", function () { hidePreview(false); });
    var thumb = card.querySelector(".roc-shaft-thumb");
    if (thumb) thumb.addEventListener("click", function (ev) {
      ev.preventDefault();
      ev.stopPropagation();
      var box = document.querySelector(".roc-shaft-preview");
      if (box && box.classList.contains("is-pinned") && box.querySelector("img").src === img.src) hidePreview(true);
      else showPreview(img.src, card, true);
    });
  }

  function enhanceTourForm(root) {
    root.classList.add("roc-tour-form");
    var isLab = looksLikeLabForm(root);
    var isSimplePutter = !isLab && looksLikeSimplePutter(root);
    var formKind = isLab ? "lab" : (isSimplePutter ? "putter" : "tour");
    var wrap = root.closest(".roc-builder");
    if (!wrap) {
      wrap = document.createElement("div");
      wrap.className = "roc-builder roc-builder--flat roc-builder--" + formKind;
      root.parentNode.insertBefore(wrap, root);
      wrap.appendChild(root);
    } else {
      wrap.classList.add("roc-builder--flat");
      wrap.classList.add("roc-builder--" + formKind);
      if (root.parentNode !== wrap) wrap.appendChild(root);
    }

    if (wrap.dataset.rocTourBuilt === "1") return;
    wrap.dataset.rocTourBuilt = "1";

    var STEP_META = isLab
      ? [
          { title: "Setup", note: "Hand and how you putt." },
          { title: "Shaft", note: "Shaft, length, lean, lie." },
          { title: "Head", note: "Colour and alignment marks." },
          { title: "Grip", note: "Grip, headcover, and any extras." }
        ]
      : isSimplePutter
        ? [
            { title: "Head", note: "Hand, loft, and lie." },
            { title: "Shaft", note: "Choose your shaft." },
            { title: "Grip", note: "Grip and any notes." }
          ]
        : [
            { title: "Shaft", note: "Material and flex for this shaft." },
            { title: "Club", note: "Club the shaft is going into." },
            { title: "Grip", note: "Golf Pride and Iomic. Size filters the models." },
            { title: "Notes", note: "Anything we should know." }
          ];
    var stepCount = STEP_META.length;
    var lastStepIndex = stepCount - 1;

    function makeStep(num, meta) {
      var step = document.createElement("div");
      step.className = "roc-builder__step";
      step.setAttribute("data-roc-step", String(num));
      step.innerHTML =
        '<button type="button" class="roc-builder__step-head" aria-expanded="false">' +
          '<span class="roc-builder__step-num">' + num + '</span>' +
          '<h3 class="roc-builder__step-title">' + meta.title + '</h3>' +
          '<span class="roc-builder__step-status" data-roc-step-status></span>' +
          '<span class="roc-builder__step-chevron" aria-hidden="true"></span>' +
        '</button>' +
        '<div class="roc-builder__step-panel">' +
          '<div class="roc-builder__step-panel-inner">' +
            '<p class="roc-builder__step-note">' + meta.note + '</p>' +
            '<div class="roc-builder__step-body"></div>' +
            (num < stepCount ? '<button type="button" class="roc-builder__continue">Continue</button>' : '') +
          '</div>' +
        '</div>';
      return step;
    }

    if (!wrap.querySelector(".roc-builder__summary")) {
      var summary = document.createElement("div");
      summary.className = "roc-builder__summary";
      var summaryMeta = isLab ? "Custom putter" : (isSimplePutter ? "Custom putter" : "Tour shaft");
      summary.innerHTML =
        '<div><h2 class="roc-builder__summary-title">Your build</h2>' +
        '<div class="roc-builder__summary-meta" data-roc-meta>' + summaryMeta + '</div></div>';
      wrap.insertBefore(summary, wrap.firstChild);
    }

    if (!wrap.querySelector(".roc-builder__progress")) {
      var progress = document.createElement("div");
      progress.className = "roc-builder__progress";
      var marks = "";
      for (var mi = 0; mi < stepCount; mi++) marks += "<i></i>";
      progress.innerHTML =
        '<div class="roc-builder__progress-label" data-roc-progress-label>Step 1 of ' + stepCount + ' · ' + STEP_META[0].title + '</div>' +
        '<div class="roc-builder__progress-track" data-roc-progress-track>' + marks + '</div>';
      var after = wrap.querySelector(".roc-builder__summary");
      wrap.insertBefore(progress, after ? after.nextSibling : wrap.firstChild);
    }

    var steps = [];
    var bodies = [];
    for (var si = 0; si < stepCount; si++) {
      var stepEl = makeStep(si + 1, STEP_META[si]);
      steps.push(stepEl);
      bodies.push(stepEl.querySelector(".roc-builder__step-body"));
    }
    var currentStep = 0;
    for (var sj = steps.length - 1; sj >= 0; sj--) root.insertBefore(steps[sj], root.firstChild);

    function kindOf(opt) {
      var t = titleOf(opt).toLowerCase();
      if (isLab) {
        if (t.indexOf("please note") > -1 || t.indexOf("player name") > -1 || t.indexOf("special instruction") > -1) return 3;
        if (t.indexOf("term") > -1 || t.indexOf("condition") > -1 || t.indexOf("t&c") > -1 || t.indexOf("agree") > -1) return 3;
        if (t.indexOf("headcover") > -1 || t.indexOf("head cover") > -1 || t.indexOf("build time") > -1) return 3;
        if (t.indexOf("grip") > -1 && t.indexOf("shaft") === -1) return 3;
        if (t.indexOf("putter color") > -1 || t.indexOf("putter colour") > -1 || t.indexOf("alignment") > -1) return 2;
        if (t.indexOf("shaft") > -1 || t.indexOf("insert") > -1 || t.indexOf("lie") > -1) return 1;
        if (t.indexOf("hand") > -1 || t.indexOf("putting") > -1 || t.indexOf("head weight") > -1) return 0;
        return 3;
      }
      if (isSimplePutter) {
        if (t.indexOf("grip") > -1 || t.indexOf("wrap") > -1 || t.indexOf("logo") > -1) return 2;
        if (t.indexOf("please note") > -1 || (t.indexOf("note") > -1 && t.indexOf("loft") === -1) || t.indexOf("term") > -1 || t.indexOf("condition") > -1 || t.indexOf("t&c") > -1 || t.indexOf("agree") > -1) return 2;
        if (t.indexOf("shaft") > -1 || t.indexOf("flex") > -1 || t.indexOf("length") > -1) return 1;
        if (t.indexOf("hand") > -1 || t.indexOf("dexterity") > -1 || t.indexOf("loft") > -1 || t.indexOf("lie") > -1) return 0;
        return 2;
      }
      if (t.indexOf("please note") > -1 || (t.indexOf("note") > -1 && t.indexOf("club") === -1)) return 3;
      if (t.indexOf("term") > -1 || t.indexOf("condition") > -1 || t.indexOf("t&c") > -1 || t.indexOf("agree") > -1) return 3;
      if (t.indexOf("grip") > -1 || t.indexOf("wrap") > -1 || t.indexOf("logo") > -1) return 2;
      if (t.indexOf("club") > -1 || t.indexOf("length") > -1 || t.indexOf("loft") > -1 || t.indexOf("sleeve") > -1 || t.indexOf("build info") > -1) return 1;
      if (t.indexOf("weight") > -1 || t.indexOf("flex") > -1) return 0;
      return 3;
    }

    function place() {
      var lastBody = bodies[lastStepIndex];
      wrap.querySelectorAll(".bold_option").forEach(function (opt) {
        var dest = bodies[kindOf(opt)] || lastBody;
        if (opt.parentNode !== dest) dest.appendChild(opt);
      });
      lastBody.querySelectorAll(".bold_option").forEach(function (opt) {
        var t = titleOf(opt).toLowerCase();
        if (t.indexOf("please note") > -1 || t.indexOf("term") > -1 || t.indexOf("condition") > -1 || t.indexOf("t&c") > -1)
          lastBody.appendChild(opt);
      });
    }

    function closeMenus(except) {
      wrap.querySelectorAll(".roc-dd.is-open").forEach(function (dd) {
        if (dd !== except) dd.classList.remove("is-open");
      });
    }

    function shouldRebuildCards(opt) {
      if (opt.querySelector('input[type="text"], textarea')) return false;
      var t = titleOf(opt).toLowerCase();
      if (!t) return false;
      if (t.indexOf("please note") > -1 || t.indexOf("special instruction") > -1 || t.indexOf("player name") > -1) return false;
      if (t.indexOf("club build") > -1 || t.indexOf("club type") > -1) return false;
      if (t.indexOf("grip brand") > -1 || t.indexOf("grip size") > -1 || t.indexOf("grip logo") > -1) return false;
      if (t.indexOf("wraps of tape") > -1 || t.indexOf("shaft length") > -1 || t.indexOf("shaft weight") > -1 || t.indexOf("weight & flex") > -1) return false;
      if (t.indexOf("shaft lean") > -1 || t.indexOf("lie angle") > -1 || t.indexOf("insert") > -1) return false;
      if (t.indexOf("putting style") > -1 || t.indexOf("head weight") > -1 || t.indexOf("build time") > -1) return false;
      if (t === "hand" || (t.indexOf("hand") === 0 && t.indexOf("head") === -1 && t.length < 12)) return false;
      if (t.indexOf("grip model") > -1) return true;
      if (t.indexOf("loft sleeve") > -1) return true;
      if (t.indexOf("putter color") > -1 || t.indexOf("putter colour") > -1) return true;
      if (t.indexOf("alignment") > -1) return true;
      if (t.indexOf("headcover") > -1 || t.indexOf("head cover") > -1) return true;
      if (t === "shaft" || t.indexOf("shaft (cb)") > -1 || /^shaft\s*\(/.test(t)) return true;
      if (t === "grip" || /^grip\s*\(/.test(t)) return true;
      if (opt.classList.contains("bold_option_swatch") || opt.querySelector(".bold_option_value_swatch")) return true;
      return false;
    }

    function swatchKind(t) {
      t = (t || "").toLowerCase();
      if (t.indexOf("loft") > -1 || t.indexOf("sleeve") > -1) return "sleeve";
      if (t.indexOf("alignment") > -1) return "align";
      if (t.indexOf("grip") > -1) return "grip";
      return "swatch";
    }

    function filterTourGrip(name, brand) {
      var nl = (name || "").toLowerCase();
      var isIomic = nl.indexOf("iomic") > -1;
      var isGP = nl.indexOf("golf pride") > -1;
      if (brand.indexOf("iomic") > -1) return !isGP;
      if (brand.indexOf("golf pride") > -1) return !isIomic;
      return true;
    }

    function applyNativeGripFilter() {
      if (isLab) return;
      var brand = tourGripBrand(root);
      root.querySelectorAll(".bold_option").forEach(function (opt) {
        var t = titleOf(opt).toLowerCase();
        if (t.indexOf("grip model") === -1) return;
        opt.querySelectorAll(".bold_option_value").forEach(function (row) {
          var titleEl = row.querySelector(".bold_option_value_title, .bold_option_value_text, .swatch-title");
          if (!titleEl) titleEl = row;
          var name = (titleEl.textContent || "").replace(/\s+/g, " ").trim();
          var hide = !filterTourGrip(name, brand);
          row.style.display = hide ? "none" : "";
          // Do not rewrite SC grip titles — prices stay in the option labels.
        });
      });
    }

    function rebuildDropdowns() {
      wrap.querySelectorAll(".bold_option_dropdown").forEach(function (opt) {
        if (opt.classList.contains("bold_option_hidden")) return;
        if (shouldRebuildCards(opt)) return;
        var titleRaw = titleOf(opt);
        var placeholder = chooseLabel(titleRaw);
        var select = opt.querySelector("select");
        var host = opt.querySelector(".bold_option_element");
        if (!select || !host) return;
        var options = optionList(select);
        var key = optionKey(options);
        var dd = opt.querySelector(".roc-dd");
        var selectedLabel = select.value && select.selectedIndex >= 0
          ? cleanName(select.options[select.selectedIndex].text)
          : "";
        var isPlaceholder = !select.value || !selectedLabel ||
          selectedLabel.indexOf("--") > -1 ||
          selectedLabel.toLowerCase().indexOf("choose") === 0 ||
          selectedLabel.toLowerCase().indexOf("select") === 0;
        if (dd && opt.getAttribute("data-roc-dd-key") === key) {
          var btn = dd.querySelector(".roc-dd__btn");
          if (btn) {
            btn.textContent = isPlaceholder ? placeholder : selectedLabel;
            btn.classList.toggle("is-placeholder", isPlaceholder);
          }
          dd.querySelectorAll(".roc-dd__opt").forEach(function (item) {
            item.classList.toggle("is-selected", item.getAttribute("data-value") === select.value);
          });
          return;
        }
        opt.setAttribute("data-roc-dd-key", key);
        if (!dd) {
          dd = document.createElement("div");
          dd.className = "roc-dd";
          host.appendChild(dd);
        }
        dd.innerHTML = "";
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "roc-dd__btn" + (isPlaceholder ? " is-placeholder" : "");
        btn.textContent = isPlaceholder ? placeholder : selectedLabel;
        var list = document.createElement("div");
        list.className = "roc-dd__list";
        options.forEach(function (o) {
          var item = document.createElement("button");
          item.type = "button";
          item.className = "roc-dd__opt" + (select.value === o.value ? " is-selected" : "");
          item.setAttribute("data-value", o.value);
          item.textContent = cleanName(o.text);
          item.addEventListener("click", function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            select.value = o.value;
            select.dispatchEvent(new Event("change", { bubbles: true }));
            btn.textContent = cleanName(o.text);
            btn.classList.remove("is-placeholder");
            list.querySelectorAll(".roc-dd__opt").forEach(function (n) { n.classList.remove("is-selected"); });
            item.classList.add("is-selected");
            dd.classList.remove("is-open");
            paintProgress();
          });
          list.appendChild(item);
        });
        btn.addEventListener("click", function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var open = !dd.classList.contains("is-open");
          closeMenus(dd);
          dd.classList.toggle("is-open", open);
        });
        dd.appendChild(btn);
        dd.appendChild(list);
      });
    }

    function cardLabel(o, isGripModel) {
      var raw = (o.text || "").replace(/\s+/g, " ").trim();
      if (hasPriceTbd(raw)) {
        return { name: raw, priceHtml: "" };
      }
      if (isGripModel && !isLab) {
        var pretty = tourGripPriceLabel(raw);
        var name = cleanName(pretty);
        var price = parsePrice(pretty);
        return {
          name: name,
          priceHtml: "<b>" + (price ? "+£" + price.toFixed(0) : "No upcharge") + "</b>"
        };
      }
      var name = cleanName(raw);
      var price = parsePrice(raw);
      if (isLab) {
        return { name: name, priceHtml: price ? "<b>+£" + price.toFixed(0) + "</b>" : "" };
      }
      return {
        name: name,
        priceHtml: "<b>" + (price ? "+£" + price.toFixed(0) : "No upcharge") + "</b>"
      };
    }

    function rebuildCards() {
      var brand = isLab ? "" : tourGripBrand(root);
      wrap.querySelectorAll(".bold_option").forEach(function (opt) {
        if (opt.classList.contains("bold_option_hidden")) return;
        if (!shouldRebuildCards(opt)) return;
        var t = titleOf(opt);
        var tl = t.toLowerCase();
        var kind = swatchKind(t);
        opt.setAttribute("data-roc-kind", kind);
        var host = opt.querySelector(".bold_option_element") || opt;
        var items = optionItems(opt);
        if (!items.length) return;
        var current = selectedItemValue(opt);
        var isGripModel = tl.indexOf("grip model") > -1 || (kind === "grip" && !isLab);
        var isAlign = kind === "align";
        var isGripCard = kind === "grip";
        var key = items.map(function (o) { return o.value + ":" + o.text + ":" + (o.image || ""); }).join("|") +
          "|" + brand + "|" + kind;
        var grid = opt.querySelector(".roc-shaft-grid");
        if (grid && opt.getAttribute("data-roc-card-key") === key) {
          grid.querySelectorAll(".roc-shaft-card").forEach(function (card) {
            card.classList.toggle("is-selected", card.getAttribute("data-value") === current);
            if (isGripModel) {
              var nm = card.getAttribute("data-name") || "";
              card.style.display = filterTourGrip(nm, brand) ? "" : "none";
            }
          });
          return;
        }
        opt.setAttribute("data-roc-card-key", key);
        if (!grid) {
          grid = document.createElement("div");
          grid.className = "roc-shaft-grid";
          if (isAlign) grid.classList.add("roc-align-grid");
          if (isGripCard) grid.classList.add("roc-grip-grid");
          host.appendChild(grid);
        } else {
          grid.className = "roc-shaft-grid" + (isAlign ? " roc-align-grid" : "") + (isGripCard ? " roc-grip-grid" : "");
        }
        grid.innerHTML = "";
        items.forEach(function (o) {
          if (isGripModel && !filterTourGrip(o.text, brand)) return;
          var meta = cardLabel(o, isGripModel);
          var card = document.createElement("button");
          card.type = "button";
          var cls = "roc-shaft-card";
          if (isGripCard) cls += " roc-grip-card";
          if (isAlign) cls += " roc-align-card";
          if (current === o.value) cls += " is-selected";
          card.className = cls;
          card.setAttribute("data-value", o.value);
          card.setAttribute("data-name", o.text);
          var src = httpImage(o.image);
          if (isGripCard && !src) src = tourGripImg(cleanName(o.text)) || tourGripImg(o.text);
          if (!src) card.classList.add("roc-card--plain");
          card.innerHTML =
            (src ? '<span class="roc-shaft-thumb' + (isGripCard ? " roc-grip-thumb" : "") + (isAlign ? " roc-align-thumb" : "") + '"><img alt="" src="' + src + '"></span>' : "") +
            "<div><strong>" + meta.name + "</strong></div>" +
            meta.priceHtml;
          if (src) bindCardPreview(card);
          card.addEventListener("click", function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            applyOptionItem(o);
            grid.querySelectorAll(".roc-shaft-card").forEach(function (c) { c.classList.remove("is-selected"); });
            card.classList.add("is-selected");
            paintProgress();
          });
          grid.appendChild(card);
        });
      });
    }

    function optionFilled(opt) {
      if (optionIsHidden(opt) || optionTitleIsOptional(opt)) return true;
      if (opt.querySelector(".roc-shaft-card.is-selected, .roc-dd__btn:not(.is-placeholder)")) return true;
      var boxes = opt.querySelectorAll('input[type="checkbox"], input[type="radio"]');
      if (boxes.length) {
        for (var i = 0; i < boxes.length; i++) if (boxes[i].checked) return true;
        return false;
      }
      var sel = opt.querySelector("select");
      if (sel) return !!sel.value;
      var field = opt.querySelector('input[type="text"], textarea');
      if (field) return true;
      return true;
    }

    function stepFilled(step) {
      var opts = step.querySelectorAll(".bold_option");
      var any = false;
      for (var i = 0; i < opts.length; i++) {
        if (optionIsHidden(opts[i])) continue;
        any = true;
        if (!optionFilled(opts[i])) return false;
      }
      return any;
    }

    var filledState = [];
    for (var fi = 0; fi < stepCount; fi++) filledState.push(false);
    var holdStep = false;

    function openStep(index, opts) {
      opts = opts || {};
      if (index < 0) index = 0;
      if (index > lastStepIndex) index = lastStepIndex;
      if (opts.hold) holdStep = true;
      currentStep = index;
      steps.forEach(function (step, i) {
        var open = i === index;
        step.classList.toggle("is-open", open);
        var head = step.querySelector(".roc-builder__step-head");
        if (head) head.setAttribute("aria-expanded", open ? "true" : "false");
      });
      paintProgress();
    }

    function paintProgress() {
      steps.forEach(function (step, i) {
        var done = stepFilled(step);
        step.classList.toggle("is-done", done);
        var status = step.querySelector("[data-roc-step-status]");
        if (status) status.textContent = done ? "Done" : "";
      });
      var label = wrap.querySelector("[data-roc-progress-label]");
      if (label) label.textContent = "Step " + (currentStep + 1) + " of " + stepCount + " · " + STEP_META[currentStep].title;
      var marks = wrap.querySelectorAll("[data-roc-progress-track] i");
      marks.forEach(function (el, i) {
        el.classList.toggle("is-done", i < currentStep || (i === currentStep && stepFilled(steps[i])));
        el.classList.toggle("is-current", i === currentStep);
      });
      wrap.querySelectorAll(".roc-builder__continue").forEach(function (btn) {
        var step = btn.closest(".roc-builder__step");
        btn.disabled = !(step && stepFilled(step));
      });
    }

    function refreshFilled() {
      steps.forEach(function (step, i) { filledState[i] = stepFilled(step); });
    }

    function maybeAdvance() {
      if (holdStep || currentStep === 0 || currentStep >= lastStepIndex) {
        paintProgress();
        refreshFilled();
        return;
      }
      var now = stepFilled(steps[currentStep]);
      var became = now && !filledState[currentStep];
      refreshFilled();
      if (became) openStep(currentStep + 1);
      else paintProgress();
    }

    function update() {
      place();
      applyNativeGripFilter();
      rebuildDropdowns();
      rebuildCards();
      paintProgress();
      if (!swatchMapReady && !swatchMapFetching) {
        swatchMapFetching = true;
        var before = Object.keys(swatchByName).length;
        fetchSwatchMap(function () {
          var justFilled = Object.keys(swatchByName).length > before;
          swatchMapReady = true;
          if (justFilled) update();
        });
      }
    }

    wrap.addEventListener("click", function (ev) {
      var head = ev.target.closest(".roc-builder__step-head");
      if (head && wrap.contains(head)) {
        ev.preventDefault();
        ev.stopPropagation();
        var step = head.closest(".roc-builder__step");
        var idx = steps.indexOf(step);
        if (idx > -1) openStep(idx, { hold: true });
        return;
      }
      var go = ev.target.closest(".roc-builder__continue");
      if (go && wrap.contains(go)) {
        ev.preventDefault();
        var step = go.closest(".roc-builder__step");
        var idx = steps.indexOf(step);
        if (idx > -1 && stepFilled(step) && idx < 3) {
          holdStep = false;
          filledState[idx] = true;
          openStep(idx + 1);
        }
      }
    });

    wrap.addEventListener("change", function () {
      holdStep = false;
      update();
      maybeAdvance();
    });
    document.addEventListener("click", function (ev) {
      if (!wrap.contains(ev.target) || !ev.target.closest(".roc-dd")) closeMenus();
    });
    var ticking = false;
    function schedule() {
      if (ticking) return;
      ticking = true;
      setTimeout(function () { ticking = false; update(); }, 80);
    }
    var mo = new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var t = recs[i].target;
        var cls = (t && t.className) || "";
        if (typeof cls === "string" && (
          cls.indexOf("roc-shaft-card") > -1 ||
          cls.indexOf("roc-shaft-grid") > -1 ||
          cls.indexOf("roc-align-grid") > -1 ||
          cls.indexOf("roc-dd") > -1 ||
          (cls.indexOf("roc-builder") > -1 && recs[i].type === "attributes")
        )) continue;
        schedule();
        return;
      }
    });
    mo.observe(wrap, { attributes: true, childList: true, subtree: true, attributeFilter: ["class"] });
    update();
    openStep(0, false);
  }

  function looksLikeIronsBuilder(root) {
    var titles = "";
    root.querySelectorAll(".bold_option_title").forEach(function (el) {
      titles += " " + ((el.textContent || "").toLowerCase());
    });
    return titles.indexOf("shaft material") > -1 || titles.indexOf("club number") > -1 || titles.indexOf("ferrule") > -1;
  }

  function enhance() {
    var root = document.querySelector(".bold_options.bold_options_loaded") || document.querySelector(".bold_options");
    if (!root || root.dataset.rocReady === "1" || root.dataset.rocReady === "skip") return root;
    if (!root.querySelector(".bold_option_title")) return false;
    if (!looksLikeIronsBuilder(root)) {
      root.dataset.rocReady = "skip";
      enhanceTourForm(root);
      return root;
    }
    var wrap = document.createElement("div");
    wrap.className = "roc-builder";
    root.parentNode.insertBefore(wrap, root);

    var summary = document.createElement("div");
    summary.className = "roc-builder__summary";
    summary.innerHTML =
      '<div><h2 class="roc-builder__summary-title">Your build</h2>' +
      '<div class="roc-builder__summary-meta" data-roc-meta>Select clubs to start</div></div>' +
      '<div class="roc-builder__summary-price" data-roc-price>£0<span>estimated total</span></div>';
    wrap.appendChild(summary);

    var STEP_META = [
      { title: "Set makeup", note: "Price is per club. Pick every iron in the set." },
      { title: "Shaft", note: "Material and flex filter the shafts you can buy." },
      { title: "Grip", note: "Golf Pride and Iomic. Size filters the models." },
      { title: "Loft / lie / ferrule", note: "Set-wide specs. Custom ferrules are Fresh Ferrule Co." }
    ];

    function makeStep(num, meta) {
      var step = document.createElement("div");
      step.className = "roc-builder__step";
      step.setAttribute("data-roc-step", String(num));
      step.innerHTML =
        '<button type="button" class="roc-builder__step-head" aria-expanded="false">' +
          '<span class="roc-builder__step-num">' + num + '</span>' +
          '<h3 class="roc-builder__step-title">' + meta.title + '</h3>' +
          '<span class="roc-builder__step-status" data-roc-step-status></span>' +
          '<span class="roc-builder__step-chevron" aria-hidden="true"></span>' +
        '</button>' +
        '<div class="roc-builder__step-panel">' +
          '<div class="roc-builder__step-panel-inner">' +
            '<p class="roc-builder__step-note">' + meta.note + '</p>' +
            '<div class="roc-builder__step-body"></div>' +
            (num < 4 ? '<button type="button" class="roc-builder__continue">Continue</button>' : '') +
          '</div>' +
        '</div>';
      return step;
    }

    var progress = document.createElement("div");
    progress.className = "roc-builder__progress";
    progress.innerHTML =
      '<div class="roc-builder__progress-label" data-roc-progress-label>Step 1 of 4 · Set makeup</div>' +
      '<div class="roc-builder__progress-track" data-roc-progress-track><i></i><i></i><i></i><i></i></div>';
    wrap.insertBefore(progress, summary.nextSibling);

    var step1 = makeStep(1, STEP_META[0]);
    var step2 = makeStep(2, STEP_META[1]);
    var step3 = makeStep(3, STEP_META[2]);
    var step4 = makeStep(4, STEP_META[3]);
    var step1Body = step1.querySelector(".roc-builder__step-body");
    var step2Body = step2.querySelector(".roc-builder__step-body");
    var step3Body = step3.querySelector(".roc-builder__step-body");
    var step4Body = step4.querySelector(".roc-builder__step-body");
    var steps = [step1, step2, step3, step4];
    var currentStep = 0;

    wrap.appendChild(root);
    root.insertBefore(step4, root.firstChild);
    root.insertBefore(step3, root.firstChild);
    root.insertBefore(step2, root.firstChild);
    root.insertBefore(step1, root.firstChild);
    root.dataset.rocReady = "1";

    function kindOf(opt) {
      var t = text(opt.querySelector(".bold_option_title")).toLowerCase();
      if (t.indexOf("dexterity") > -1 || t.indexOf("club") > -1) return "set";
      if (t.indexOf("grip") > -1 || t.indexOf("wrap") > -1 || t.indexOf("logo") > -1) return "grip";
      if (
        t.indexOf("loft") > -1 || t.indexOf("lie") > -1 || t.indexOf("ferrule") > -1 ||
        t.indexOf("notes") > -1 || t.indexOf("please note") > -1 ||
        t.indexOf("term") > -1 || t.indexOf("condition") > -1 || t.indexOf("t&c") > -1 ||
        t.indexOf("agree") > -1
      ) return "finish";
      return "shaft";
    }

    function place() {
      wrap.querySelectorAll(".bold_option").forEach(function (opt) {
        var k = kindOf(opt);
        var dest = step2Body;
        if (k === "set") dest = step1Body;
        else if (k === "grip") dest = step3Body;
        else if (k === "finish") dest = step4Body;
        if (opt.parentNode !== dest) dest.appendChild(opt);
      });
      step4Body.querySelectorAll(".bold_option").forEach(function (opt) {
        var t = text(opt.querySelector(".bold_option_title")).toLowerCase();
        if (t.indexOf("term") > -1 || t.indexOf("condition") > -1 || t.indexOf("please note") > -1 || t.indexOf("t&c") > -1)
          step4Body.appendChild(opt);
      });
    }

    function closeMenus(except) {
      wrap.querySelectorAll(".roc-dd.is-open").forEach(function (dd) {
        if (dd !== except) dd.classList.remove("is-open");
      });
    }

    function rebuildBrands() {
      wrap.querySelectorAll(".bold_option_dropdown").forEach(function (opt) {
        if (optionIsHidden(opt)) return;
        var title = text(opt.querySelector(".bold_option_title")).toLowerCase();
        if (title.indexOf("shaft brand") === -1) return;
        opt.setAttribute("data-roc-kind", "brand");
        var select = opt.querySelector("select");
        var host = opt.querySelector(".bold_option_element");
        if (!select || !host) return;
        select.required = false;
        select.removeAttribute("required");
        if (opt.classList) opt.classList.remove("bold_option_required");
        var options = optionList(select);
        var key = optionKey(options);
        var dd = opt.querySelector(".roc-dd");
        if (dd && opt.getAttribute("data-roc-brand-key") === key) {
          var label = select.value && select.selectedIndex >= 0
            ? cleanName(select.options[select.selectedIndex].text)
            : "All brands";
          var btn = dd.querySelector(".roc-dd__btn");
          if (btn) {
            btn.textContent = label;
            btn.classList.toggle("is-placeholder", !select.value);
          }
          dd.querySelectorAll(".roc-dd__opt").forEach(function (item) {
            item.classList.toggle("is-selected", item.getAttribute("data-value") === select.value);
          });
          return;
        }
        opt.setAttribute("data-roc-brand-key", key);
        if (!dd) {
          dd = document.createElement("div");
          dd.className = "roc-dd";
          host.appendChild(dd);
        }
        dd.innerHTML = "";
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "roc-dd__btn" + (select.value ? "" : " is-placeholder");
        btn.textContent = select.value && select.selectedIndex >= 0
          ? cleanName(select.options[select.selectedIndex].text)
          : "All brands";
        var list = document.createElement("div");
        list.className = "roc-dd__list";
        var allItem = document.createElement("button");
        allItem.type = "button";
        allItem.className = "roc-dd__opt" + (!select.value ? " is-selected" : "");
        allItem.setAttribute("data-value", "");
        allItem.textContent = "All brands";
        allItem.addEventListener("click", function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          // Filter UX only — do not blank the native select (SC Required Shaft Brand / Mizuno ATC).
          wrap.setAttribute("data-roc-all-brands", "1");
          btn.textContent = "All brands";
          btn.classList.add("is-placeholder");
          list.querySelectorAll(".roc-dd__opt").forEach(function (n) { n.classList.remove("is-selected"); });
          allItem.classList.add("is-selected");
          dd.classList.remove("is-open");
          rebuildModels();
          refreshTotals();
        });
        list.appendChild(allItem);
        options.forEach(function (o) {
          var item = document.createElement("button");
          item.type = "button";
          item.className = "roc-dd__opt" + (select.value === o.value ? " is-selected" : "");
          item.setAttribute("data-value", o.value);
          item.textContent = cleanName(o.text);
          item.addEventListener("click", function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            wrap.removeAttribute("data-roc-all-brands");
            select.value = o.value;
            select.dispatchEvent(new Event("change", { bubbles: true }));
            btn.textContent = cleanName(o.text);
            btn.classList.remove("is-placeholder");
            list.querySelectorAll(".roc-dd__opt").forEach(function (n) { n.classList.remove("is-selected"); });
            item.classList.add("is-selected");
            dd.classList.remove("is-open");
            refreshTotals();
          });
          list.appendChild(item);
        });
        btn.addEventListener("click", function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var open = !dd.classList.contains("is-open");
          closeMenus(dd);
          dd.classList.toggle("is-open", open);
        });
        dd.appendChild(btn);
        dd.appendChild(list);
      });
    }


    function ensurePreview() {
      var box = document.querySelector(".roc-shaft-preview");
      if (box) return box;
      box = document.createElement("div");
      box.className = "roc-shaft-preview";
      box.innerHTML = "<img alt=\"Shaft preview\">";
      document.body.appendChild(box);
      document.addEventListener("click", function (ev) {
        if (ev.target.closest && ev.target.closest(".roc-shaft-thumb")) return;
        hidePreview(true);
      });
      return box;
    }

    function showPreview(src, card, pin) {
      var box = ensurePreview();
      box.querySelector("img").src = src;
      box.classList.add("is-visible");
      box.classList.toggle("is-pinned", !!pin);
      var r = card.getBoundingClientRect();
      var w = Math.min(320, window.innerWidth - 24);
      var left = r.right + 10;
      if (left + w > window.innerWidth - 12) left = Math.max(12, r.left - w - 10);
      if (left < 12) left = 12;
      var top = Math.max(12, Math.min(r.top, window.innerHeight - 180));
      box.style.width = w + "px";
      box.style.left = left + "px";
      box.style.top = top + "px";
    }

    function hidePreview(force) {
      var box = document.querySelector(".roc-shaft-preview");
      if (!box) return;
      if (box.classList.contains("is-pinned") && !force) return;
      box.classList.remove("is-visible", "is-pinned");
    }


    function themeAsset(name) {
      var el = document.querySelector('script[src*="roc-builder.js"], link[href*="roc-builder.css"]');
      var href = el ? (el.src || el.href || "") : "";
      if (!href) return name;
      return href.replace(/roc-builder\.(js|css)[^/]*$/, name);
    }

    function selectedShaftMaterial() {
      var mat = "";
      wrap.querySelectorAll(".bold_option").forEach(function (opt) {
        if (optionIsHidden(opt)) return;
        var t = text(opt.querySelector(".bold_option_title")).toLowerCase();
        if (t.indexOf("material") === -1) return;
        if (t.indexOf("shaft model") > -1) return;
        var sel = opt.querySelector("select");
        if (sel && sel.value && sel.selectedIndex >= 0) {
          var txt = sel.options[sel.selectedIndex].text || "";
          var low = txt.toLowerCase();
          if (low && low.indexOf("choose") === -1 && low.indexOf("select") === -1 && low.indexOf("--") !== 0) mat = txt;
        }
        var checked = opt.querySelector("input:checked");
        if (checked) mat = text(checked.parentNode) || text((checked.closest && checked.closest("label")) || checked.parentNode) || mat;
      });
      var low = (mat || "").toLowerCase();
      if (low.indexOf("graphite") > -1) return "graphite";
      if (low.indexOf("steel") > -1) return "steel";
      return "";
    }

    function modelMaterial(name) {
      var n = (name || "").toLowerCase();
      if (
        n.indexOf("tgi") > -1 ||
        n.indexOf("axiom") > -1 ||
        n.indexOf("fujikura") > -1 ||
        n.indexOf("steelfiber") > -1 ||
        n.indexOf("steel fiber") > -1 ||
        n.indexOf("aerotech") > -1 ||
        n.indexOf("mmt") > -1 ||
        n.indexOf("mitsubishi") > -1 ||
        n.indexOf("graphite") > -1 ||
        n.indexOf("tour ad") > -1 ||
        n.indexOf("recoil") > -1 ||
        n.indexOf("autoflex") > -1 ||
        n.indexOf("ust") > -1 ||
        n.indexOf("helium") > -1 ||
        n.indexOf("miyazaki") > -1 ||
        n.indexOf("diamana") > -1 ||
        n.indexOf("tensei") > -1
      ) return "graphite";
      return "steel";
    }

    function selectedShaftBrand() {
      // UI filter only — SC may still need a real select value (see syncShaftBrandFromSelectedModel).
      if (wrap.getAttribute("data-roc-all-brands") === "1") return "";
      var brand = "";
      wrap.querySelectorAll(".bold_option").forEach(function (opt) {
        if (optionIsHidden(opt)) return;
        var t = text(opt.querySelector(".bold_option_title")).toLowerCase();
        if (t.indexOf("shaft brand") === -1) return;
        var sel = opt.querySelector("select");
        if (sel && sel.value && sel.selectedIndex >= 0) {
          var txt = sel.options[sel.selectedIndex].text || "";
          var low = txt.toLowerCase();
          if (low && low.indexOf("choose") === -1 && low.indexOf("select") === -1 && low.indexOf("--") !== 0) brand = txt;
        }
        var checked = opt.querySelector("input:checked");
        if (checked) brand = text(checked.parentNode) || brand;
      });
      return brand.toLowerCase();
    }

    function prettyBrand(b) {
      if (!b) return "";
      if (b === "accra") return "ACCRA";
      if (b === "ust mamiya") return "UST Mamiya";
      return b.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }

    function setShaftEmpty(grid, brand) {
      var visible = 0;
      grid.querySelectorAll(".roc-shaft-card").forEach(function (c) {
        if (c.style.display !== "none") visible += 1;
      });
      var note = grid.querySelector(".roc-empty");
      if (visible) {
        if (note) note.parentNode.removeChild(note);
        return;
      }
      var msg = brand
        ? "No " + prettyBrand(brand) + " shafts in this flex yet. Try another brand or flex."
        : "No shafts in this flex yet. Try another flex.";
      if (!note) {
        note = document.createElement("div");
        note.className = "roc-empty";
        grid.appendChild(note);
      }
      note.textContent = msg;
    }

    function normalizeBrandText(s) {
      return ((s || "") + "").toLowerCase().replace(/[.]/g, " ").replace(/\s+/g, " ").trim();
    }

    function brandMatchTokens(brandLabel) {
      var raw = ((brandLabel || "") + "").replace(/[()]/g, " ");
      var parts = raw.split(/[/|,;]+/);
      var tokens = [];
      var seen = {};
      parts.forEach(function (part) {
        var p = normalizeBrandText(part);
        if (!p) return;
        if (p.indexOf("choose") > -1 || p.indexOf("select") > -1 || p.indexOf("all brand") > -1) return;
        var variants = [p, p.replace(/\s+/g, "")];
        variants.forEach(function (t) {
          if (!t || t.length < 2 || seen[t]) return;
          seen[t] = 1;
          tokens.push(t);
        });
      });
      return tokens;
    }

    function shaftMatchesBrand(shaftName, brandLabel) {
      if (!brandLabel) return true;
      var n = normalizeBrandText(shaftName);
      var compact = n.replace(/\s+/g, "");
      var tokens = brandMatchTokens(brandLabel);
      if (!tokens.length) return false;
      for (var i = 0; i < tokens.length; i++) {
        var t = tokens[i];
        if (n.indexOf(t) > -1) return true;
        if (compact.indexOf(t.replace(/\s+/g, "")) > -1) return true;
      }
      return false;
    }

    // SC marks Shaft Brand Required on some sets (e.g. Mizuno). "All brands" used to
    // leave the native select empty, so options.js blocked ATC. Keep the filter UX, but
    // when a shaft model is chosen, sync every visible Shaft Brand select to the matching brand.
    function syncShaftBrandFromSelectedModel() {
      var shaftLabel = "";
      wrap.querySelectorAll('.bold_option[data-roc-kind="model"]').forEach(function (opt) {
        if (optionIsHidden(opt)) return;
        var label = selectedOptionLabel(opt);
        if (label) shaftLabel = label;
      });
      if (!shaftLabel) {
        // Fallback: selected card text
        var card = wrap.querySelector('.bold_option[data-roc-kind="model"] .roc-shaft-card.is-selected');
        if (card) shaftLabel = card.getAttribute("data-name") || "";
      }
      if (!shaftLabel) return false;
      var changed = false;
      wrap.querySelectorAll(".bold_option").forEach(function (opt) {
        if (optionIsHidden(opt)) return;
        var t = text(opt.querySelector(".bold_option_title")).toLowerCase();
        if (t.indexOf("shaft brand") === -1) return;
        var select = opt.querySelector("select");
        if (!select) return;
        var options = optionList(select);
        var best = null;
        var bestLen = 0;
        options.forEach(function (o) {
          var label = cleanName(o.text);
          if (!label) return;
          if (!shaftMatchesBrand(shaftLabel, label)) return;
          var score = brandMatchTokens(label).reduce(function (m, tok) { return Math.max(m, tok.length); }, 0);
          if (score > bestLen) {
            bestLen = score;
            best = o;
          }
        });
        if (!best || select.value === best.value) {
          if (best) {
            var btnOk = opt.querySelector(".roc-dd__btn");
            if (btnOk && (!select.value || btnOk.classList.contains("is-placeholder"))) {
              btnOk.textContent = cleanName(best.text);
              btnOk.classList.remove("is-placeholder");
            }
          }
          return;
        }
        select.value = best.value;
        try { select.dispatchEvent(new Event("input", { bubbles: true })); } catch (e1) {}
        select.dispatchEvent(new Event("change", { bubbles: true }));
        var btn = opt.querySelector(".roc-dd__btn");
        if (btn) {
          btn.textContent = cleanName(best.text);
          btn.classList.remove("is-placeholder");
        }
        opt.querySelectorAll(".roc-dd__opt").forEach(function (item) {
          item.classList.toggle("is-selected", item.getAttribute("data-value") === best.value);
        });
        changed = true;
      });
      return changed;
    }

    // Resolves which Shaft Brand dropdown option a shaft belongs to (SC-driven).
    // Adam can add aliases on the brand option itself: "Nippon / N.S.Pro / Zelos".
    function modelBrand(name) {
      var labels = [];
      var seen = {};
      wrap.querySelectorAll(".bold_option").forEach(function (opt) {
        var t = text(opt.querySelector(".bold_option_title")).toLowerCase();
        if (t.indexOf("shaft brand") === -1) return;
        var select = opt.querySelector("select");
        if (!select) return;
        optionList(select).forEach(function (o) {
          var label = cleanName(o.text);
          var key = normalizeBrandText(label);
          if (!key || seen[key]) return;
          seen[key] = 1;
          labels.push(label);
        });
      });
      var best = "";
      var bestLen = 0;
      labels.forEach(function (label) {
        if (!shaftMatchesBrand(name, label)) return;
        var score = brandMatchTokens(label).reduce(function (m, t) { return Math.max(m, t.length); }, 0);
        if (score > bestLen) {
          bestLen = score;
          best = normalizeBrandText(label);
        }
      });
      return best;
    }

    /* disabled 2026-08-27: photos now come from SC swatches
    function shaftImage(name) {
      var n = (name || "").toLowerCase();
      if (n.indexOf("amt silver") > -1) return themeAsset("shaft-amt-silver.webp");
      if (n.indexOf("amt red") > -1) return themeAsset("shaft-amt-red.webp");
      if (n.indexOf("amt black") > -1) return themeAsset("shaft-amt-black.webp");
      if (n.indexOf("amt white") > -1) return themeAsset("shaft-amt-white.webp");
      if (n.indexOf("tour issue") > -1) return themeAsset("shaft-dg-tour-issue.webp");
      if (n.indexOf("x7") > -1) return themeAsset("shaft-dg-x7.webp");
      if (n.indexOf("dynamic gold") > -1 && n.indexOf("mid") > -1) return themeAsset("shaft-dg-mid-115.webp");
      if (n.indexOf("dynamic gold 95") > -1) return themeAsset("shaft-dg-95.webp");
      if (n.indexOf("dynamic gold 105") > -1) return themeAsset("shaft-dg-105.webp");
      if (n.indexOf("dynamic gold") > -1) return themeAsset("shaft-dg.webp");
      if (n.indexOf("axiom") > -1 || n.indexOf("fujikura") > -1) return themeAsset("shaft-fujikura-axiom.webp");
      if (n.indexOf("steelfiber") > -1 || n.indexOf("aerotech") > -1) return themeAsset("shaft-aerotech-steelfiber.webp");
      if (n.indexOf("tgi") > -1) return themeAsset("shaft-kbs-tgi.webp");
      return SHAFT_IMG;
    }
    */
    function shaftImage(name) { return ""; }

    /* disabled 2026-08-27: photos now come from SC swatches
    function ferruleImage(name) {
      var n = (name || "").toLowerCase();
      if (n.indexOf("ocean") > -1) return themeAsset("ferrule-ocean.webp");
      if (n.indexOf("tiffany") > -1) return themeAsset("ferrule-tiffany.webp");
      if (n.indexOf("white knight") > -1) return themeAsset("ferrule-white-knight.webp");
      if (n.indexOf("thunderbird") > -1) return themeAsset("ferrule-thunderbird.webp");
      if (n.indexOf("surf") > -1) return themeAsset("ferrule-surf.webp");
      if (n.indexOf("shark") > -1) return themeAsset("ferrule-shark.webp");
      if (n.indexOf("jura") > -1) return themeAsset("ferrule-jura-gold.webp");
      if (n.indexOf("hot pink") > -1 || n.indexOf("hotpink") > -1) return themeAsset("ferrule-hot-pink.webp");
      if (n.indexOf("emerald") > -1) return themeAsset("ferrule-emerald.webp");
      if (n.indexOf("chilli") > -1 || n.indexOf("chili") > -1) return themeAsset("ferrule-chilli.webp");
      if (n.indexOf("barcode") > -1) return themeAsset("ferrule-barcode.webp");
      return "";
    }
    */
    function ferruleImage(name) { return ""; }

    function rebuildFerrules() {
      wrap.querySelectorAll(".bold_option").forEach(function (opt) {
        var title = text(opt.querySelector(".bold_option_title")).toLowerCase();
        if (title.indexOf("ferrule") === -1) return;
        opt.setAttribute("data-roc-kind", "ferrule");
        var host = opt.querySelector(".bold_option_element") || opt;
        var items = optionItems(opt);
        if (!items.length) return;
        var current = selectedItemValue(opt);
        var key = items.map(function (o) { return o.value + ":" + o.text + ":" + (o.image || ""); }).join("|") + "|ferrule-v2";
        var grid = opt.querySelector(".roc-ferrule-grid");
        if (grid && opt.getAttribute("data-roc-ferrule-key") === key) {
          grid.querySelectorAll(".roc-shaft-card").forEach(function (card) {
            card.classList.toggle("is-selected", card.getAttribute("data-value") === current);
          });
          return;
        }
        opt.setAttribute("data-roc-ferrule-key", key);
        if (!grid) {
          grid = document.createElement("div");
          grid.className = "roc-ferrule-grid roc-shaft-grid";
          host.appendChild(grid);
        }
        grid.innerHTML = "";
        items.forEach(function (o) {
          var name = cleanName(o.text);
          var card = document.createElement("button");
          card.type = "button";
          card.className = "roc-shaft-card roc-ferrule-card" + (current === o.value ? " is-selected" : "");
          card.setAttribute("data-value", o.value);
          var price = parsePrice(o.text);
          if (name.toLowerCase().indexOf("standard") > -1) price = 0;
          var src = httpImage(o.image);
          var note = src ? "" : "<em>Photo coming</em>";
          card.innerHTML =
            (src ? '<span class="roc-shaft-thumb roc-ferrule-thumb"><img alt="" src="' + src + '"></span>' : "") +
            "<div><strong>" + name + "</strong>" + note + "</div>" +
            "<b>" + (price ? "+£" + price.toFixed(0) : "No upcharge") + "</b>";
          if (src) {
            var img = card.querySelector("img");
            card.addEventListener("mouseenter", function () { showPreview(img.src, card, false); });
            card.addEventListener("mouseleave", function () { hidePreview(false); });
            var thumb = card.querySelector(".roc-shaft-thumb");
            if (thumb) thumb.addEventListener("click", function (ev) {
              ev.preventDefault();
              ev.stopPropagation();
              showPreview(img.src, card, true);
            });
          }
          card.addEventListener("click", function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            applyOptionItem(o);
            grid.querySelectorAll(".roc-shaft-card").forEach(function (c) { c.classList.remove("is-selected"); });
            card.classList.add("is-selected");
            refreshTotals();
          });
          grid.appendChild(card);
        });
      });
    }

    function selectedBrand() {
      var brand = "";
      wrap.querySelectorAll(".bold_option").forEach(function (opt) {
        if (opt.classList.contains("bold_option_hidden")) return;
        var t = text(opt.querySelector(".bold_option_title")).toLowerCase();
        if (t.indexOf("grip brand") === -1) return;
        var checked = opt.querySelector("input:checked");
        if (checked) {
          var lab = checked.closest ? checked.closest("label") : null;
          if (!lab && checked.id) lab = opt.querySelector('label[for="' + checked.id + '"]');
          brand = text(lab) || text(checked.parentNode) || checked.value || "";
        } else {
          var sel = opt.querySelector("select");
          if (sel && sel.value && sel.selectedIndex >= 0) brand = sel.options[sel.selectedIndex].text || "";
        }
      });
      brand = (brand || "").toLowerCase().replace(/\s+/g, " ").trim();
      if (brand.indexOf("iomic") > -1) return "iomic";
      if (brand.indexOf("golf pride") > -1 || brand.indexOf("golfpride") > -1) return "golf pride";
      return brand;
    }

    function gripModelBrand(name) {
      var n = (name || "").toLowerCase();
      if (n.indexOf("iomic") > -1 || n.indexOf("sticky") > -1 || n.indexOf("ix sa") > -1 || n.indexOf("ixx") > -1) return "iomic";
      return "golf pride";
    }

    function setGripEmpty(grid, brand) {
      var visible = 0;
      grid.querySelectorAll(".roc-shaft-card").forEach(function (c) {
        if (c.style.display !== "none") visible += 1;
      });
      var note = grid.querySelector(".roc-empty");
      if (visible) {
        if (note) note.parentNode.removeChild(note);
        return;
      }
      var msg = brand === "iomic"
        ? "No Iomic grips in this size. Try another size."
        : brand === "golf pride"
          ? "No Golf Pride grips in this size. Try another size."
          : "Pick a grip brand to see models.";
      if (!note) {
        note = document.createElement("div");
        note.className = "roc-empty";
        grid.appendChild(note);
      }
      note.textContent = msg;
    }

    function gripPrice(name) {
      // Always trust SC labels. Never invent GP/Iomic upcharges in the theme.
      return parsePrice(name) || 0;
    }

    function gripImage(name) {
      if (GRIP_IMGS[name]) return GRIP_IMGS[name];
      var keys = Object.keys(GRIP_IMGS);
      var n = name.toLowerCase();
      for (var i = 0; i < keys.length; i++) {
        if (n.indexOf(keys[i].toLowerCase()) > -1 || keys[i].toLowerCase().indexOf(n) > -1) return GRIP_IMGS[keys[i]];
      }
      return SHAFT_IMG;
    }

    function rebuildGrips() {
      var brand = selectedBrand();
      wrap.querySelectorAll(".bold_option").forEach(function (opt) {
        if (opt.classList.contains("bold_option_hidden")) return;
        var title = text(opt.querySelector(".bold_option_title")).toLowerCase();
        if (title.indexOf("grip") === -1) return;
        if (title.indexOf("brand") > -1 || title.indexOf("size") > -1 || title.indexOf("logo") > -1) return;
        opt.setAttribute("data-roc-kind", "grip");
        var host = opt.querySelector(".bold_option_element") || opt;
        var items = optionItems(opt);
        if (!items.length) return;
        var current = selectedItemValue(opt);
        var select = opt.querySelector("select");
        var key = items.map(function (o) { return o.value + ":" + o.text + ":" + (o.image || ""); }).join("|") + "|" + brand + "|gbp-v4";
        var grid = opt.querySelector(".roc-grip-grid");
        if (grid && opt.getAttribute("data-roc-grip-key") === key) {
          grid.querySelectorAll(".roc-shaft-card").forEach(function (card) {
            card.classList.toggle("is-selected", card.getAttribute("data-value") === current);
            var b = card.getAttribute("data-brand") || "";
            card.style.display = (!brand || b.indexOf(brand) > -1 || brand.indexOf(b) > -1) ? "" : "none";
          });
          return;
        }
        opt.setAttribute("data-roc-grip-key", key);
        if (!grid) {
          grid = document.createElement("div");
          grid.className = "roc-grip-grid roc-shaft-grid";
          host.appendChild(grid);
        }
        grid.innerHTML = "";
        items.forEach(function (o) {
          var name = cleanName(o.text);
          var b = gripModelBrand(name);
          if (brand && b.indexOf(brand) === -1 && brand.indexOf(b) === -1) return;
          var card = document.createElement("button");
          card.type = "button";
          card.className = "roc-shaft-card roc-grip-card" + (current === o.value ? " is-selected" : "");
          card.setAttribute("data-value", o.value);
          card.setAttribute("data-brand", b);
          var price = gripPrice(o.text);
          var src = httpImage(o.image) || gripImage(name);
          card.innerHTML =
            '<span class="roc-shaft-thumb roc-grip-thumb"><img alt="" src="' + src + '"></span>' +
            "<div><strong>" + name + "</strong></div>" +
            "<b>" + (price ? "+£" + price.toFixed(0) : "No upcharge") + "</b>";
          var img = card.querySelector("img");
          card.addEventListener("mouseenter", function () { showPreview(img.src, card, false); });
          card.addEventListener("mouseleave", function () { hidePreview(false); });
          card.querySelector(".roc-shaft-thumb").addEventListener("click", function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            showPreview(img.src, card, true);
          });
          card.addEventListener("click", function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            if (typeof applyOptionItem === "function") applyOptionItem(o);
            else if (select) {
              select.value = o.value;
              select.dispatchEvent(new Event("change", { bubbles: true }));
            }
            grid.querySelectorAll(".roc-shaft-card").forEach(function (c) { c.classList.remove("is-selected"); });
            card.classList.add("is-selected");
            refreshTotals();
          });
          grid.appendChild(card);
        });
        setGripEmpty(grid, brand);
      });
    }

    function shaftCardVisible(brand, material, cardBrand, cardMaterial, shaftName) {
      if (brand) {
        // Prefer SC-driven token match on the shaft label; fall back to resolved card brand.
        if (shaftName) {
          if (!shaftMatchesBrand(shaftName, brand)) return false;
        } else {
          if (!cardBrand) return false;
          if (!shaftMatchesBrand(cardBrand, brand) && cardBrand.indexOf(brand) === -1 && brand.indexOf(cardBrand) === -1) return false;
        }
      }
      if (material && cardMaterial && cardMaterial !== material) return false;
      return true;
    }

    function rebuildModels() {
      wrap.querySelectorAll(".bold_option").forEach(function (opt) {
        if (optionIsHidden(opt)) return;
        var title = text(opt.querySelector(".bold_option_title")).toLowerCase();
        if (title.indexOf("grip") > -1) return;
        if (title.indexOf("shaft model") === -1) return;
        if (title.indexOf("brand") > -1) return;
        opt.setAttribute("data-roc-kind", "model");
        var host = opt.querySelector(".bold_option_element") || opt;
        var items = optionItems(opt);
        var brand = selectedShaftBrand();
        var material = selectedShaftMaterial();
        var current = selectedItemValue(opt);
        var key = items.map(function (o) { return o.value + ":" + o.text + ":" + (o.image || ""); }).join("|") + "|" + brand + "|" + material + "|shaft-v4";
        var grid = opt.querySelector(".roc-shaft-grid");
        if (grid && opt.getAttribute("data-roc-key") === key) {
          grid.querySelectorAll(".roc-shaft-card").forEach(function (card) {
            card.classList.toggle("is-selected", card.getAttribute("data-value") === current);
            var b = card.getAttribute("data-brand") || "";
            var m = card.getAttribute("data-material") || "";
            var shaftName = card.getAttribute("data-name") || "";
            card.style.display = shaftCardVisible(brand, material, b, m, shaftName) ? "" : "none";
          });
          setShaftEmpty(grid, brand);
          return;
        }
        opt.setAttribute("data-roc-key", key);
        if (!grid) {
          grid = document.createElement("div");
          grid.className = "roc-shaft-grid";
          host.appendChild(grid);
        }
        grid.innerHTML = "";
        if (!items.length) {
          setShaftEmpty(grid, brand);
          return;
        }
        items.forEach(function (o) {
          var name = cleanName(o.text);
          var b = modelBrand(name);
          var m = modelMaterial(name);
          if (!shaftCardVisible(brand, material, b, m, o.text)) return;
          var card = document.createElement("button");
          card.type = "button";
          card.className = "roc-shaft-card" + (current === o.value ? " is-selected" : "");
          card.setAttribute("data-value", o.value);
          card.setAttribute("data-name", name);
          card.setAttribute("data-brand", b);
          card.setAttribute("data-material", m);
          var price = parsePrice(o.text);
          var src = httpImage(o.image);
          var hasPhoto = !!(src && src.indexOf("placeholder") === -1);
          var note = hasPhoto ? "" : "<em>Photo coming when Adam sends it</em>";
          card.innerHTML =
            (hasPhoto ? '<span class="roc-shaft-thumb"><img alt="" src="' + src + '"></span>' : "") +
            "<div><strong>" + name + "</strong>" + note + "</div>" +
            "<b>" + (price ? "+£" + price.toFixed(0) : "No upcharge") + "</b>";
          if (hasPhoto) {
            var img = card.querySelector("img");
            card.addEventListener("mouseenter", function () { showPreview(img.src, card, false); });
            card.addEventListener("mouseleave", function () { hidePreview(false); });
            card.querySelector(".roc-shaft-thumb").addEventListener("click", function (ev) {
              ev.preventDefault();
              ev.stopPropagation();
              var box = document.querySelector(".roc-shaft-preview");
              if (box && box.classList.contains("is-pinned") && box.querySelector("img").src === img.src) hidePreview(true);
              else showPreview(img.src, card, true);
            });
          }
          card.addEventListener("click", function (ev) {
            ev.preventDefault();
            ev.stopPropagation();
            applyOptionItem(o);
            grid.querySelectorAll(".roc-shaft-card").forEach(function (c) { c.classList.remove("is-selected"); });
            card.classList.add("is-selected");
            syncShaftBrandFromSelectedModel();
            refreshTotals();
          });
          grid.appendChild(card);
        });
        setShaftEmpty(grid, brand);
      });
    }

    function ensureAtcTotal() {
      if (document.querySelector("[data-roc-atc]")) return;
      var btn = document.querySelector(
        'form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] button[type="submit"], #AddToCart, .product-form__cart-submit, button[name="add"]'
      );
      if (!btn) return;
      var box = document.createElement("div");
      box.className = "roc-builder__atc-total";
      box.setAttribute("data-roc-atc", "1");
      box.innerHTML =
        '<span class="roc-builder__atc-total-label">Estimated total</span>' +
        '<strong data-roc-atc-price>£0</strong>' +
        '<em data-roc-atc-meta></em>';
      btn.parentNode.insertBefore(box, btn);
    }

    function selectedOptionLabel(opt) {
      if (!opt) return "";
      var sel = opt.querySelector("select");
      if (sel && sel.value && sel.selectedIndex >= 0) {
        var txt = sel.options[sel.selectedIndex].text || "";
        var low = txt.toLowerCase();
        if (txt && low.indexOf("choose") === -1 && txt.indexOf("--") === -1) return txt;
      }
      var checked = opt.querySelector("input:checked");
      if (checked) {
        var lab = (checked.closest && checked.closest("label")) ||
          (checked.id && opt.querySelector('label[for="' + checked.id + '"]')) ||
          checked.parentNode;
        var raw = text(lab);
        if (raw) return raw;
      }
      var card = opt.querySelector(".roc-shaft-card.is-selected");
      if (card) {
        var val = card.getAttribute("data-value") || "";
        var items = optionItems(opt);
        for (var i = 0; i < items.length; i++) {
          if (items[i].value === val) return items[i].text;
        }
        var strong = card.querySelector("strong");
        if (strong) return text(strong);
      }
      return "";
    }

    function refreshTotals() {
      ensureAtcTotal();
      syncShaftBrandFromSelectedModel();
      var boxes = wrap.querySelectorAll('.bold_option_checkboxmulti input[type="checkbox"]:checked');
      var n = boxes.length;
      var shaftExtra = 0;
      wrap.querySelectorAll('.bold_option[data-roc-kind="model"]:not(.bold_option_hidden)').forEach(function (opt) {
        var label = selectedOptionLabel(opt);
        if (label) shaftExtra = parsePrice(label);
      });
      var gripExtra = 0;
      wrap.querySelectorAll('.bold_option[data-roc-kind="grip"]:not(.bold_option_hidden)').forEach(function (opt) {
        var label = selectedOptionLabel(opt);
        if (label) gripExtra = gripPrice(label);
      });
      var ferruleExtra = 0;
      wrap.querySelectorAll(".bold_option:not(.bold_option_hidden)").forEach(function (opt) {
        var kind = opt.getAttribute("data-roc-kind") || "";
        var title = text(opt.querySelector(".bold_option_title")).toLowerCase();
        if (kind !== "ferrule" && title.indexOf("ferrule") === -1) return;
        var label = selectedOptionLabel(opt);
        if (label) ferruleExtra = parsePrice(label) || 0;
      });
      var extras = shaftExtra + gripExtra + ferruleExtra;
      var unit = productUnitPrice();
      var total = n * (unit + extras);
      var per = unit + extras;
      var metaText = n ? n + (n === 1 ? " club" : " clubs") + " selected" : "Select clubs to start";
      var priceHtml = "£" + total.toLocaleString("en-GB") + "<span>" + (n ? "£" + per + " per club" : "estimated total") + "</span>";
      var meta = wrap.querySelector("[data-roc-meta]");
      var price = wrap.querySelector("[data-roc-price]");
      if (meta) meta.textContent = metaText;
      if (price) price.innerHTML = priceHtml;
      var atcPrice = document.querySelector("[data-roc-atc-price]");
      var atcMeta = document.querySelector("[data-roc-atc-meta]");
      if (atcPrice) atcPrice.textContent = "£" + total.toLocaleString("en-GB");
      if (atcMeta) atcMeta.textContent = n ? n + (n === 1 ? " club" : " clubs") + " · £" + per + " per club" : "Select clubs to start";
      syncQuantity(n);
    }

    function syncQuantity(n) {
      if (!n) return;
      document.querySelectorAll('form[action*="/cart/add"] [name="quantity"]').forEach(function (q) {
        q.value = String(n);
      });
    }

    function optionFilled(opt) {
      if (optionIsHidden(opt) || optionTitleIsOptional(opt)) return true;
      if (opt.querySelector(".roc-shaft-card.is-selected, .roc-dd__btn:not(.is-placeholder)")) return true;
      var boxes = opt.querySelectorAll('input[type="checkbox"], input[type="radio"]');
      if (boxes.length) {
        for (var i = 0; i < boxes.length; i++) if (boxes[i].checked) return true;
        return false;
      }
      var sel = opt.querySelector("select");
      if (sel) return !!sel.value;
      var text = opt.querySelector('input[type="text"], textarea');
      if (text) return !!(text.value && text.value.trim());
      return true;
    }

    function stepFilled(step) {
      var opts = step.querySelectorAll(".bold_option");
      var any = false;
      for (var i = 0; i < opts.length; i++) {
        if (optionIsHidden(opts[i])) continue;
        any = true;
        if (!optionFilled(opts[i])) return false;
      }
      return any;
    }

    var filledState = [false, false, false, false];
    var holdStep = false;

    function openStep(index, opts) {
      opts = opts || {};
      if (index < 0) index = 0;
      if (index > 3) index = 3;
      if (opts.hold) holdStep = true;
      currentStep = index;
      steps.forEach(function (step, i) {
        var open = i === index;
        step.classList.toggle("is-open", open);
        var head = step.querySelector(".roc-builder__step-head");
        if (head) head.setAttribute("aria-expanded", open ? "true" : "false");
      });
      paintProgress();
    }

    function paintProgress() {
      steps.forEach(function (step, i) {
        var done = stepFilled(step);
        step.classList.toggle("is-done", done);
        var status = step.querySelector("[data-roc-step-status]");
        if (status) status.textContent = done ? "Done" : "";
      });
      var label = wrap.querySelector("[data-roc-progress-label]");
      if (label) label.textContent = "Step " + (currentStep + 1) + " of 4 · " + STEP_META[currentStep].title;
      var marks = wrap.querySelectorAll("[data-roc-progress-track] i");
      marks.forEach(function (el, i) {
        el.classList.toggle("is-done", i < currentStep || (i === currentStep && stepFilled(steps[i])));
        el.classList.toggle("is-current", i === currentStep);
      });
      wrap.querySelectorAll(".roc-builder__continue").forEach(function (btn) {
        var step = btn.closest(".roc-builder__step");
        btn.disabled = !(step && stepFilled(step));
      });
    }

    function refreshFilled() {
      steps.forEach(function (step, i) { filledState[i] = stepFilled(step); });
    }

    function maybeAdvance() {
      if (holdStep || currentStep === 0 || currentStep >= 3) {
        paintProgress();
        refreshFilled();
        return;
      }
      var now = stepFilled(steps[currentStep]);
      var became = now && !filledState[currentStep];
      refreshFilled();
      if (became) openStep(currentStep + 1);
      else paintProgress();
    }

    function update() {
      place();
      rebuildBrands();
      rebuildModels();
      rebuildGrips();
      rebuildFerrules();
      refreshTotals();
      paintProgress();
      if (!swatchMapReady && !swatchMapFetching) {
        swatchMapFetching = true;
        var before = Object.keys(swatchByName).length;
        fetchSwatchMap(function () {
          var justFilled = Object.keys(swatchByName).length > before;
          swatchMapReady = true;
          if (justFilled) update();
        });
      }
    }

    wrap.addEventListener("click", function (ev) {
      var head = ev.target.closest(".roc-builder__step-head");
      if (head && wrap.contains(head)) {
        ev.preventDefault();
        ev.stopPropagation();
        var step = head.closest(".roc-builder__step");
        var idx = steps.indexOf(step);
        if (idx > -1) openStep(idx, { hold: true });
        return;
      }
      var go = ev.target.closest(".roc-builder__continue");
      if (go && wrap.contains(go)) {
        ev.preventDefault();
        var step = go.closest(".roc-builder__step");
        var idx = steps.indexOf(step);
        if (idx > -1 && stepFilled(step) && idx < 3) {
          holdStep = false;
          filledState[idx] = true;
          openStep(idx + 1);
        }
      }
    });

    wrap.addEventListener("change", function () {
      holdStep = false;
      update();
      maybeAdvance();
    });
    document.addEventListener("click", function (ev) {
      if (!wrap.contains(ev.target) || !ev.target.closest(".roc-dd")) closeMenus();
    });
    var ticking = false;
    function schedule() {
      if (ticking) return;
      ticking = true;
      setTimeout(function () { ticking = false; update(); }, 80);
    }
    var mo = new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var t = recs[i].target;
        var cls = (t && t.className) || "";
        if (typeof cls === "string" && (
          cls.indexOf("roc-shaft-card") > -1 ||
          cls.indexOf("roc-shaft-grid") > -1 ||
          cls.indexOf("roc-dd") > -1 ||
          (cls.indexOf("roc-builder") > -1 && recs[i].type === "attributes")
        )) continue;
        schedule();
        return;
      }
    });
    mo.observe(wrap, { attributes: true, childList: true, subtree: true, attributeFilter: ["class"] });
    update();
    openStep(0, false);
    return root;
  }


  function wireCartQty() {
    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || !form.getAttribute) return;
      var action = form.getAttribute("action") || "";
      if (action.indexOf("/cart/add") === -1) return;
      var n = document.querySelectorAll('.roc-builder .bold_option_checkboxmulti input[type="checkbox"]:checked').length;
      if (!n) return;
      var q = form.querySelector('[name="quantity"]');
      if (!q) {
        q = document.createElement("input");
        q.type = "hidden";
        q.name = "quantity";
        form.appendChild(q);
      }
      q.value = String(n);
    }, true);
  }

  var SHAFT_VARIANTS = {
    "Graphite Design Tour AD L": 55637089419640,
    "UST Recoil Dart A": 55637096661368,
    "Nippon Modus 105 R": 55637106360696,
    "Nippon Modus 105 S": 55637111898488,
    "Project X 6.0": 55637111931256
  };

  function clubsFromProps(props) {
    if (!props) return 0;
    var raw = props["Club Numbers"] || props["club numbers"] || "";
    return raw.split(",").map(function (s) { return s.trim(); }).filter(Boolean).length;
  }

  function shaftVariantFromProps(props) {
    if (!props) return 0;
    var raw = cleanName(props["Shaft Model"] || props["shaft model"] || "");
    var keys = Object.keys(SHAFT_VARIANTS);
    for (var i = 0; i < keys.length; i++) {
      if (raw.indexOf(keys[i]) > -1) return SHAFT_VARIANTS[keys[i]];
    }
    return 0;
  }

  function postJson(url, data) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json().catch(function () { return {}; }); });
  }

  function isOptionCompanion(item) {
    if (!item) return false;
    var props = item.properties || {};
    if (props["_roc_shaft"] || props._roc_shaft) return true;
    if (props._boldMaster || props["_boldMaster"] || props._boldVariant || props["_boldVariant"]) return true;
    var t = (item.product_title || item.title || "").toLowerCase();
    return /^(shaft model|grip model|ferrule|custom ferrule)\b/.test(t);
  }

  function lockCartQtyUi(cart) {
    if (!cart || !cart.items || !cart.items.length) return;
    var inputs = document.querySelectorAll('input[name="updates[]"], input[name^="updates["]');
    cart.items.forEach(function (item, index) {
      var n = clubsFromProps(item.properties);
      var lock = n > 0 || isOptionCompanion(item);
      if (!lock) return;
      var input = inputs[index];
      if (!input) return;
      if (n > 0) input.value = String(n);
      input.readOnly = true;
      input.setAttribute("data-roc-qty-locked", n > 0 ? String(n) : "1");
      var wrap = input.closest(".cart__quantity, .js-qty, .quantity, .cart-item__quantity, .cart__qty, td, .ajaxcart__qty");
      if (wrap) {
        wrap.classList.add("roc-qty-locked");
        wrap.querySelectorAll("button, a.js-qty__adjust, [data-qty], [data-action]").forEach(function (btn) {
          btn.setAttribute("disabled", "disabled");
          btn.setAttribute("aria-disabled", "true");
          btn.style.pointerEvents = "none";
        });
      }
    });
  }

  function wireLockedQtyGuard() {
    if (window.__rocQtyGuard) return;
    window.__rocQtyGuard = 1;
    function revert(el) {
      var locked = el.getAttribute("data-roc-qty-locked");
      if (!locked) return false;
      if (locked !== "1") el.value = locked;
      return true;
    }
    document.addEventListener("input", function (e) {
      if (e.target && revert(e.target)) e.stopPropagation();
    }, true);
    document.addEventListener("change", function (e) {
      if (e.target && revert(e.target)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
    document.addEventListener("click", function (e) {
      var btn = e.target && e.target.closest && e.target.closest(".roc-qty-locked button, .roc-qty-locked a, .roc-qty-locked [data-qty], .roc-qty-locked [data-action]");
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);
  }

  function fixCartPage() {
    if (location.pathname.indexOf("/cart") === -1) return;
    if (window.__rocCartFix) return;
    window.__rocCartFix = 1;
    wireLockedQtyGuard();
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      var body = {};
      var builderNs = [];
      var testBuilder = null;
      cart.items.forEach(function (item) {
        var n = clubsFromProps(item.properties);
        if (!n) return;
        builderNs.push(n);
        if (item.quantity !== n) body[item.key] = n;
        var title = item.product_title || item.title || "";
        if (title.indexOf("[TEST]") > -1 || item.product_id === 15048562540920) testBuilder = item;
      });
      // SC sometimes adds shaft/grip/ferrule as separate lines — keep them on the same club count.
      if (builderNs.length === 1) {
        var n = builderNs[0];
        cart.items.forEach(function (item) {
          if (clubsFromProps(item.properties)) return;
          if (!isOptionCompanion(item)) return;
          if (item.quantity !== n) body[item.key] = n;
        });
      }
      // Legacy TEST shaft-variant add-on (unchanged behaviour for the old TEST builder).
      var shaftId = 0;
      var shaftItem = null;
      if (testBuilder) {
        shaftId = shaftVariantFromProps(testBuilder.properties);
        shaftItem = cart.items.filter(function (item) { return item.variant_id === shaftId; })[0];
        var tn = clubsFromProps(testBuilder.properties);
        if (shaftItem && tn && shaftItem.quantity !== tn) body[shaftItem.key] = tn;
      }
      var chain = Object.keys(body).length ? postJson("/cart/update.js", { updates: body }) : Promise.resolve();
      chain.then(function () {
        if (testBuilder && shaftId && !shaftItem) {
          var tn = clubsFromProps(testBuilder.properties);
          return postJson("/cart/add.js", {
            items: [{ id: shaftId, quantity: tn, properties: { "_roc_shaft": "1" } }]
          }).then(function () { location.reload(); });
        }
        if (Object.keys(body).length) {
          location.reload();
          return;
        }
        lockCartQtyUi(cart);
      });
    }).catch(function () {});
  }

  ready(function () {
    wireCartQty();
    fixCartPage();
    var tries = 0;
    var t = setInterval(function () {
      tries += 1;
      if (enhance() || tries > 40) clearInterval(t);
    }, 250);
  });
})();
